/*! @algolia/autocomplete-js 1.19.2 | MIT License | © Algolia, Inc. and contributors | https://github.com/algolia/autocomplete */
!function(e, t) {
    "object" == typeof exports && "undefined" != typeof module ? t(exports) : "function" == typeof define && define.amd ? define(["exports"], t) : t((e = "undefined" != typeof globalThis ? globalThis : e || self)["@algolia/autocomplete-js"] = {})
}(this, (function(e) {
    "use strict";
    function t(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter((function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            }
            ))),
            n.push.apply(n, r)
        }
        return n
    }
    function n(e) {
        for (var n = 1; n < arguments.length; n++) {
            var r = null != arguments[n] ? arguments[n] : {};
            n % 2 ? t(Object(r), !0).forEach((function(t) {
                o(e, t, r[t])
            }
            )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : t(Object(r)).forEach((function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t))
            }
            ))
        }
        return e
    }
    function r(e) {
        return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        }
        : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        }
        ,
        r(e)
    }
    function o(e, t, n) {
        return (t = function(e) {
            var t = function(e, t) {
                if ("object" != typeof e || null === e)
                    return e;
                var n = e[Symbol.toPrimitive];
                if (void 0 !== n) {
                    var r = n.call(e, t || "default");
                    if ("object" != typeof r)
                        return r;
                    throw new TypeError("@@toPrimitive must return a primitive value.")
                }
                return ("string" === t ? String : Number)(e)
            }(e, "string");
            return "symbol" == typeof t ? t : String(t)
        }(t))in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n,
        e
    }
    function i() {
        return i = Object.assign ? Object.assign.bind() : function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];
                for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r])
            }
            return e
        }
        ,
        i.apply(this, arguments)
    }
    function u(e, t) {
        if (null == e)
            return {};
        var n, r, o = function(e, t) {
            if (null == e)
                return {};
            var n, r, o = {}, i = Object.keys(e);
            for (r = 0; r < i.length; r++)
                n = i[r],
                t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o
        }(e, t);
        if (Object.getOwnPropertySymbols) {
            var i = Object.getOwnPropertySymbols(e);
            for (r = 0; r < i.length; r++)
                n = i[r],
                t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n])
        }
        return o
    }
    function a(e, t) {
        return function(e) {
            if (Array.isArray(e))
                return e
        }(e) || function(e, t) {
            var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
            if (null != n) {
                var r, o, i, u, a = [], l = !0, c = !1;
                try {
                    if (i = (n = n.call(e)).next,
                    0 === t) {
                        if (Object(n) !== n)
                            return;
                        l = !1
                    } else
                        for (; !(l = (r = i.call(n)).done) && (a.push(r.value),
                        a.length !== t); l = !0)
                            ;
                } catch (e) {
                    c = !0,
                    o = e
                } finally {
                    try {
                        if (!l && null != n.return && (u = n.return(),
                        Object(u) !== u))
                            return
                    } finally {
                        if (c)
                            throw o
                    }
                }
                return a
            }
        }(e, t) || c(e, t) || function() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }()
    }
    function l(e) {
        return function(e) {
            if (Array.isArray(e))
                return s(e)
        }(e) || function(e) {
            if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"])
                return Array.from(e)
        }(e) || c(e) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }()
    }
    function c(e, t) {
        if (e) {
            if ("string" == typeof e)
                return s(e, t);
            var n = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === n && e.constructor && (n = e.constructor.name),
            "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? s(e, t) : void 0
        }
    }
    function s(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++)
            r[n] = e[n];
        return r
    }
    function f(e) {
        return {
            current: e
        }
    }
    function p(e, t) {
        var n = void 0;
        return function() {
            for (var r = arguments.length, o = new Array(r), i = 0; i < r; i++)
                o[i] = arguments[i];
            n && clearTimeout(n),
            n = setTimeout((function() {
                return e.apply(void 0, o)
            }
            ), t)
        }
    }
    function m(e) {
        return e.reduce((function(e, t) {
            return e.concat(t)
        }
        ), [])
    }
    var v = 0;
    function d() {
        return "autocomplete-".concat(v++)
    }
    function y(e, t) {
        return t.reduce((function(e, t) {
            return e && e[t]
        }
        ), e)
    }
    function b(e) {
        return 0 === e.collections.length ? 0 : e.collections.reduce((function(e, t) {
            return e + t.items.length
        }
        ), 0)
    }
    function g(e) {
        return e !== Object(e)
    }
    function h(e, t) {
        if (e === t)
            return !0;
        if (g(e) || g(t) || "function" == typeof e || "function" == typeof t)
            return e === t;
        if (Object.keys(e).length !== Object.keys(t).length)
            return !1;
        for (var n = 0, r = Object.keys(e); n < r.length; n++) {
            var o = r[n];
            if (!(o in t))
                return !1;
            if (!h(e[o], t[o]))
                return !1
        }
        return !0
    }
    var _ = function() {};
    var O = "1.19.2"
      , S = [{
        segment: "autocomplete-core",
        version: O
    }];
    function j(e) {
        var t = e.item
          , n = e.items
          , r = void 0 === n ? [] : n;
        return {
            index: t.__autocomplete_indexName,
            items: [t],
            positions: [1 + r.findIndex((function(e) {
                return e.objectID === t.objectID
            }
            ))],
            queryID: t.__autocomplete_queryID,
            algoliaSource: ["autocomplete"]
        }
    }
    function P(e, t) {
        return function(e) {
            if (Array.isArray(e))
                return e
        }(e) || function(e, t) {
            var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
            if (null != n) {
                var r, o, i, u, a = [], l = !0, c = !1;
                try {
                    if (i = (n = n.call(e)).next,
                    0 === t) {
                        if (Object(n) !== n)
                            return;
                        l = !1
                    } else
                        for (; !(l = (r = i.call(n)).done) && (a.push(r.value),
                        a.length !== t); l = !0)
                            ;
                } catch (e) {
                    c = !0,
                    o = e
                } finally {
                    try {
                        if (!l && null != n.return && (u = n.return(),
                        Object(u) !== u))
                            return
                    } finally {
                        if (c)
                            throw o
                    }
                }
                return a
            }
        }(e, t) || function(e, t) {
            if (!e)
                return;
            if ("string" == typeof e)
                return w(e, t);
            var n = Object.prototype.toString.call(e).slice(8, -1);
            "Object" === n && e.constructor && (n = e.constructor.name);
            if ("Map" === n || "Set" === n)
                return Array.from(e);
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
                return w(e, t)
        }(e, t) || function() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }()
    }
    function w(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++)
            r[n] = e[n];
        return r
    }
    var I = ["items"]
      , A = ["items"];
    function E(e) {
        return E = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        }
        : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        }
        ,
        E(e)
    }
    function D(e) {
        return function(e) {
            if (Array.isArray(e))
                return C(e)
        }(e) || function(e) {
            if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"])
                return Array.from(e)
        }(e) || function(e, t) {
            if (!e)
                return;
            if ("string" == typeof e)
                return C(e, t);
            var n = Object.prototype.toString.call(e).slice(8, -1);
            "Object" === n && e.constructor && (n = e.constructor.name);
            if ("Map" === n || "Set" === n)
                return Array.from(e);
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
                return C(e, t)
        }(e) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }()
    }
    function C(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++)
            r[n] = e[n];
        return r
    }
    function k(e, t) {
        if (null == e)
            return {};
        var n, r, o = function(e, t) {
            if (null == e)
                return {};
            var n, r, o = {}, i = Object.keys(e);
            for (r = 0; r < i.length; r++)
                n = i[r],
                t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o
        }(e, t);
        if (Object.getOwnPropertySymbols) {
            var i = Object.getOwnPropertySymbols(e);
            for (r = 0; r < i.length; r++)
                n = i[r],
                t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n])
        }
        return o
    }
    function x(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter((function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            }
            ))),
            n.push.apply(n, r)
        }
        return n
    }
    function N(e) {
        for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? x(Object(n), !0).forEach((function(t) {
                T(e, t, n[t])
            }
            )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : x(Object(n)).forEach((function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
            }
            ))
        }
        return e
    }
    function T(e, t, n) {
        return (t = function(e) {
            var t = function(e, t) {
                if ("object" !== E(e) || null === e)
                    return e;
                var n = e[Symbol.toPrimitive];
                if (void 0 !== n) {
                    var r = n.call(e, t || "default");
                    if ("object" !== E(r))
                        return r;
                    throw new TypeError("@@toPrimitive must return a primitive value.")
                }
                return ("string" === t ? String : Number)(e)
            }(e, "string");
            return "symbol" === E(t) ? t : String(t)
        }(t))in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n,
        e
    }
    function q(e) {
        for (var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 20, n = [], r = 0; r < e.objectIDs.length; r += t)
            n.push(N(N({}, e), {}, {
                objectIDs: e.objectIDs.slice(r, r + t)
            }));
        return n
    }
    function B(e) {
        return e.map((function(e) {
            var t = e.items
              , n = k(e, I);
            return N(N({}, n), {}, {
                objectIDs: (null == t ? void 0 : t.map((function(e) {
                    return e.objectID
                }
                ))) || n.objectIDs
            })
        }
        ))
    }
    function R(e) {
        var t, n, r, o = (t = P((e.version || "").split(".").map(Number), 2),
        n = t[0],
        r = t[1],
        n >= 3 || 2 === n && r >= 4 || 1 === n && r >= 10);
        function i(t, n, r) {
            if (o && void 0 !== r) {
                var i = r[0].__autocomplete_algoliaCredentials
                  , u = {
                    "X-Algolia-Application-Id": i.appId,
                    "X-Algolia-API-Key": i.apiKey
                };
                e.apply(void 0, [t].concat(D(n), [{
                    headers: u
                }]))
            } else
                e.apply(void 0, [t].concat(D(n)))
        }
        return {
            init: function(t, n) {
                e("init", {
                    appId: t,
                    apiKey: n
                })
            },
            setAuthenticatedUserToken: function(t) {
                e("setAuthenticatedUserToken", t)
            },
            setUserToken: function(t) {
                e("setUserToken", t)
            },
            clickedObjectIDsAfterSearch: function() {
                for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
                    t[n] = arguments[n];
                t.length > 0 && i("clickedObjectIDsAfterSearch", B(t), t[0].items)
            },
            clickedObjectIDs: function() {
                for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
                    t[n] = arguments[n];
                t.length > 0 && i("clickedObjectIDs", B(t), t[0].items)
            },
            clickedFilters: function() {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
                    n[r] = arguments[r];
                n.length > 0 && e.apply(void 0, ["clickedFilters"].concat(n))
            },
            convertedObjectIDsAfterSearch: function() {
                for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
                    t[n] = arguments[n];
                t.length > 0 && i("convertedObjectIDsAfterSearch", B(t), t[0].items)
            },
            convertedObjectIDs: function() {
                for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
                    t[n] = arguments[n];
                t.length > 0 && i("convertedObjectIDs", B(t), t[0].items)
            },
            convertedFilters: function() {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
                    n[r] = arguments[r];
                n.length > 0 && e.apply(void 0, ["convertedFilters"].concat(n))
            },
            viewedObjectIDs: function() {
                for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
                    t[n] = arguments[n];
                t.length > 0 && t.reduce((function(e, t) {
                    var n = t.items
                      , r = k(t, A);
                    return [].concat(D(e), D(q(N(N({}, r), {}, {
                        objectIDs: (null == n ? void 0 : n.map((function(e) {
                            return e.objectID
                        }
                        ))) || r.objectIDs
                    })).map((function(e) {
                        return {
                            items: n,
                            payload: e
                        }
                    }
                    ))))
                }
                ), []).forEach((function(e) {
                    var t = e.items;
                    return i("viewedObjectIDs", [e.payload], t)
                }
                ))
            },
            viewedFilters: function() {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
                    n[r] = arguments[r];
                n.length > 0 && e.apply(void 0, ["viewedFilters"].concat(n))
            }
        }
    }
    function L(e) {
        var t = e.items.reduce((function(e, t) {
            var n;
            return e[t.__autocomplete_indexName] = (null !== (n = e[t.__autocomplete_indexName]) && void 0 !== n ? n : []).concat(t),
            e
        }
        ), {});
        return Object.keys(t).map((function(e) {
            return {
                index: e,
                items: t[e],
                algoliaSource: ["autocomplete"]
            }
        }
        ))
    }
    function F(e) {
        return e.objectID && e.__autocomplete_indexName && e.__autocomplete_queryID
    }
    function U(e) {
        return U = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        }
        : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        }
        ,
        U(e)
    }
    function M(e) {
        return function(e) {
            if (Array.isArray(e))
                return H(e)
        }(e) || function(e) {
            if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"])
                return Array.from(e)
        }(e) || function(e, t) {
            if (!e)
                return;
            if ("string" == typeof e)
                return H(e, t);
            var n = Object.prototype.toString.call(e).slice(8, -1);
            "Object" === n && e.constructor && (n = e.constructor.name);
            if ("Map" === n || "Set" === n)
                return Array.from(e);
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
                return H(e, t)
        }(e) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }()
    }
    function H(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++)
            r[n] = e[n];
        return r
    }
    function V(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter((function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            }
            ))),
            n.push.apply(n, r)
        }
        return n
    }
    function W(e) {
        for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? V(Object(n), !0).forEach((function(t) {
                Q(e, t, n[t])
            }
            )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : V(Object(n)).forEach((function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
            }
            ))
        }
        return e
    }
    function Q(e, t, n) {
        return (t = function(e) {
            var t = function(e, t) {
                if ("object" !== U(e) || null === e)
                    return e;
                var n = e[Symbol.toPrimitive];
                if (void 0 !== n) {
                    var r = n.call(e, t || "default");
                    if ("object" !== U(r))
                        return r;
                    throw new TypeError("@@toPrimitive must return a primitive value.")
                }
                return ("string" === t ? String : Number)(e)
            }(e, "string");
            return "symbol" === U(t) ? t : String(t)
        }(t))in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n,
        e
    }
    var K = "2.15.0"
      , $ = "https://cdn.jsdelivr.net/npm/search-insights@".concat(K, "/dist/search-insights.min.js")
      , z = p((function(e) {
        var t = e.onItemsChange
          , n = e.items
          , r = e.insights
          , o = e.state;
        t({
            insights: r,
            insightsEvents: L({
                items: n
            }).map((function(e) {
                return W({
                    eventName: "Items Viewed"
                }, e)
            }
            )),
            state: o
        })
    }
    ), 400);
    function G(e) {
        var t = function(e) {
            return W({
                onItemsChange: function(e) {
                    var t = e.insights
                      , n = e.insightsEvents
                      , r = e.state;
                    t.viewedObjectIDs.apply(t, M(n.map((function(e) {
                        return W(W({}, e), {}, {
                            algoliaSource: J(e.algoliaSource, r.context)
                        })
                    }
                    ))))
                },
                onSelect: function(e) {
                    var t = e.insights
                      , n = e.insightsEvents
                      , r = e.state;
                    t.clickedObjectIDsAfterSearch.apply(t, M(n.map((function(e) {
                        return W(W({}, e), {}, {
                            algoliaSource: J(e.algoliaSource, r.context)
                        })
                    }
                    ))))
                },
                onActive: _,
                __autocomplete_clickAnalytics: !0
            }, e)
        }(e)
          , n = t.insightsClient
          , r = t.insightsInitParams
          , o = t.onItemsChange
          , i = t.onSelect
          , u = t.onActive
          , a = t.__autocomplete_clickAnalytics
          , l = n;
        if (n || function(e) {
            if ("undefined" != typeof window)
                e({
                    window: window
                })
        }((function(e) {
            var t = e.window
              , n = t.AlgoliaAnalyticsObject || "aa";
            "string" == typeof n && (l = t[n]),
            l || (t.AlgoliaAnalyticsObject = n,
            t[n] || (t[n] = function() {
                t[n].queue || (t[n].queue = []);
                for (var e = arguments.length, r = new Array(e), o = 0; o < e; o++)
                    r[o] = arguments[o];
                t[n].queue.push(r)
            }
            ),
            t[n].version = K,
            l = t[n],
            function(e) {
                var t = "[Autocomplete]: Could not load search-insights.js. Please load it manually following https://alg.li/insights-autocomplete";
                try {
                    var n = e.document.createElement("script");
                    n.async = !0,
                    n.src = $,
                    n.onerror = function() {
                        console.error(t)
                    }
                    ,
                    document.body.appendChild(n)
                } catch (e) {
                    console.error(t)
                }
            }(t))
        }
        )),
        !l)
            return {};
        r && l("init", W({
            partial: !0
        }, r));
        var c = R(l)
          , s = f([])
          , m = p((function(e) {
            var t = e.state;
            if (t.isOpen) {
                var n = t.collections.reduce((function(e, t) {
                    return [].concat(M(e), M(t.items))
                }
                ), []).filter(F);
                h(s.current.map((function(e) {
                    return e.objectID
                }
                )), n.map((function(e) {
                    return e.objectID
                }
                ))) || (s.current = n,
                n.length > 0 && z({
                    onItemsChange: o,
                    items: n,
                    insights: c,
                    state: t
                }))
            }
        }
        ), 0);
        return {
            name: "aa.algoliaInsightsPlugin",
            subscribe: function(e) {
                var t = e.setContext
                  , n = e.onSelect
                  , r = e.onActive;
                function o(e) {
                    t({
                        algoliaInsightsPlugin: {
                            __algoliaSearchParameters: W(W({}, a ? {
                                clickAnalytics: !0
                            } : {}), e ? {
                                userToken: X(e)
                            } : {}),
                            insights: c
                        }
                    })
                }
                l("addAlgoliaAgent", "insights-plugin"),
                o(),
                l("onUserTokenChange", (function(e) {
                    o(e)
                }
                )),
                l("getUserToken", null, (function(e, t) {
                    o(t)
                }
                )),
                n((function(e) {
                    var t = e.item
                      , n = e.state
                      , r = e.event
                      , o = e.source;
                    F(t) && i({
                        state: n,
                        event: r,
                        insights: c,
                        item: t,
                        insightsEvents: [W({
                            eventName: "Item Selected"
                        }, j({
                            item: t,
                            items: o.getItems().filter(F)
                        }))]
                    })
                }
                )),
                r((function(e) {
                    var t = e.item
                      , n = e.source
                      , r = e.state
                      , o = e.event;
                    F(t) && u({
                        state: r,
                        event: o,
                        insights: c,
                        item: t,
                        insightsEvents: [W({
                            eventName: "Item Active"
                        }, j({
                            item: t,
                            items: n.getItems().filter(F)
                        }))]
                    })
                }
                ))
            },
            onStateChange: function(e) {
                var t = e.state;
                m({
                    state: t
                })
            },
            __autocomplete_pluginOptions: e
        }
    }
    function J() {
        var e, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], n = arguments.length > 1 ? arguments[1] : void 0;
        return [].concat(M(t), ["autocomplete-internal"], M(null !== (e = n.algoliaInsightsPlugin) && void 0 !== e && e.__automaticInsights ? ["autocomplete-automatic"] : []))
    }
    function X(e) {
        return "number" == typeof e ? e.toString() : e
    }
    function Y(e, t) {
        var n = t;
        return {
            then: function(t, r) {
                return Y(e.then(ee(t, n, e), ee(r, n, e)), n)
            },
            catch: function(t) {
                return Y(e.catch(ee(t, n, e)), n)
            },
            finally: function(t) {
                return t && n.onCancelList.push(t),
                Y(e.finally(ee(t && function() {
                    return n.onCancelList = [],
                    t()
                }
                , n, e)), n)
            },
            cancel: function() {
                n.isCanceled = !0;
                var e = n.onCancelList;
                n.onCancelList = [],
                e.forEach((function(e) {
                    e()
                }
                ))
            },
            isCanceled: function() {
                return !0 === n.isCanceled
            }
        }
    }
    function Z(e) {
        return Y(e, {
            isCanceled: !1,
            onCancelList: []
        })
    }
    function ee(e, t, n) {
        return e ? function(n) {
            return t.isCanceled ? n : e(n)
        }
        : n
    }
    var te, ne = !0;
    function re(e, t, n, r) {
        if (!n)
            return null;
        if (e < 0 && (null === t || null !== r && 0 === t))
            return n + e;
        var o = (null === t ? -1 : t) + e;
        return o <= -1 || o >= n ? null === r ? null : 0 : o
    }
    function oe(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter((function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            }
            ))),
            n.push.apply(n, r)
        }
        return n
    }
    function ie(e) {
        for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? oe(Object(n), !0).forEach((function(t) {
                ue(e, t, n[t])
            }
            )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : oe(Object(n)).forEach((function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
            }
            ))
        }
        return e
    }
    function ue(e, t, n) {
        return (t = function(e) {
            var t = function(e, t) {
                if ("object" !== ae(e) || null === e)
                    return e;
                var n = e[Symbol.toPrimitive];
                if (void 0 !== n) {
                    var r = n.call(e, t || "default");
                    if ("object" !== ae(r))
                        return r;
                    throw new TypeError("@@toPrimitive must return a primitive value.")
                }
                return ("string" === t ? String : Number)(e)
            }(e, "string");
            return "symbol" === ae(t) ? t : String(t)
        }(t))in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n,
        e
    }
    function ae(e) {
        return ae = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        }
        : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        }
        ,
        ae(e)
    }
    function le(e, t) {
        var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (!n) {
            if (Array.isArray(e) || (n = function(e, t) {
                if (!e)
                    return;
                if ("string" == typeof e)
                    return ce(e, t);
                var n = Object.prototype.toString.call(e).slice(8, -1);
                "Object" === n && e.constructor && (n = e.constructor.name);
                if ("Map" === n || "Set" === n)
                    return Array.from(e);
                if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
                    return ce(e, t)
            }(e)) || t && e && "number" == typeof e.length) {
                n && (e = n);
                var r = 0
                  , o = function() {};
                return {
                    s: o,
                    n: function() {
                        return r >= e.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: e[r++]
                        }
                    },
                    e: function(e) {
                        throw e
                    },
                    f: o
                }
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }
        var i, u = !0, a = !1;
        return {
            s: function() {
                n = n.call(e)
            },
            n: function() {
                var e = n.next();
                return u = e.done,
                e
            },
            e: function(e) {
                a = !0,
                i = e
            },
            f: function() {
                try {
                    u || null == n.return || n.return()
                } finally {
                    if (a)
                        throw i
                }
            }
        }
    }
    function ce(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++)
            r[n] = e[n];
        return r
    }
    var se = function(e, t) {
        var n, r = !1, o = [], i = le(e);
        try {
            for (i.s(); !(n = i.n()).done; ) {
                var u, a, l, c = null === (u = n.value.__autocomplete_pluginOptions) || void 0 === u || null === (a = (l = u).awaitSubmit) || void 0 === a ? void 0 : a.call(l);
                if ("number" == typeof c)
                    o.push(c);
                else if (!0 === c) {
                    r = !0;
                    break
                }
            }
        } catch (e) {
            i.e(e)
        } finally {
            i.f()
        }
        return r ? t.wait() : o.length > 0 ? t.wait(Math.max.apply(Math, o)) : void 0
    };
    function fe(e) {
        var t = function(e) {
            var t = e.collections.map((function(e) {
                return e.items.length
            }
            )).reduce((function(e, t, n) {
                var r = (e[n - 1] || 0) + t;
                return e.push(r),
                e
            }
            ), []).reduce((function(t, n) {
                return n <= e.activeItemId ? t + 1 : t
            }
            ), 0);
            return e.collections[t]
        }(e);
        if (!t)
            return null;
        var n = t.items[function(e) {
            for (var t = e.state, n = e.collection, r = !1, o = 0, i = 0; !1 === r; ) {
                var u = t.collections[o];
                if (u === n) {
                    r = !0;
                    break
                }
                i += u.items.length,
                o++
            }
            return t.activeItemId - i
        }({
            state: e,
            collection: t
        })]
          , r = t.source;
        return {
            item: n,
            itemInputValue: r.getItemInputValue({
                item: n,
                state: e
            }),
            itemUrl: r.getItemUrl({
                item: n,
                state: e
            }),
            source: r
        }
    }
    function pe(e, t, n) {
        return [e, null == n ? void 0 : n.sourceId, t].filter(Boolean).join("-").replace(/\s/g, "")
    }
    var me = /((gt|sm)-|galaxy nexus)|samsung[- ]|samsungbrowser/i;
    function ve(e) {
        return e.nativeEvent || e
    }
    function de(e) {
        return de = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        }
        : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        }
        ,
        de(e)
    }
    function ye(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter((function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            }
            ))),
            n.push.apply(n, r)
        }
        return n
    }
    function be(e, t, n) {
        return (t = function(e) {
            var t = function(e, t) {
                if ("object" !== de(e) || null === e)
                    return e;
                var n = e[Symbol.toPrimitive];
                if (void 0 !== n) {
                    var r = n.call(e, t || "default");
                    if ("object" !== de(r))
                        return r;
                    throw new TypeError("@@toPrimitive must return a primitive value.")
                }
                return ("string" === t ? String : Number)(e)
            }(e, "string");
            return "symbol" === de(t) ? t : String(t)
        }(t))in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n,
        e
    }
    function ge(e, t, n) {
        var r, o = t.initialState;
        return {
            getState: function() {
                return o
            },
            dispatch: function(r, i) {
                var u = function(e) {
                    for (var t = 1; t < arguments.length; t++) {
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? ye(Object(n), !0).forEach((function(t) {
                            be(e, t, n[t])
                        }
                        )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ye(Object(n)).forEach((function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
                        }
                        ))
                    }
                    return e
                }({}, o);
                o = e(o, {
                    type: r,
                    props: t,
                    payload: i
                }),
                n({
                    state: o,
                    prevState: u
                })
            },
            pendingRequests: (r = [],
            {
                add: function(e) {
                    return r.push(e),
                    e.finally((function() {
                        r = r.filter((function(t) {
                            return t !== e
                        }
                        ))
                    }
                    ))
                },
                cancelAll: function() {
                    r.forEach((function(e) {
                        return e.cancel()
                    }
                    ))
                },
                isEmpty: function() {
                    return 0 === r.length
                },
                wait: function(e) {
                    return ne ? (ne = !1,
                    te = e ? Promise.race([Promise.all(r), new Promise((function(t) {
                        return setTimeout(t, e)
                    }
                    ))]) : Promise.all(r),
                    te.then((function() {
                        ne = !0
                    }
                    ))) : te
                }
            })
        }
    }
    function he(e) {
        return he = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        }
        : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        }
        ,
        he(e)
    }
    function _e(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter((function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            }
            ))),
            n.push.apply(n, r)
        }
        return n
    }
    function Oe(e) {
        for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? _e(Object(n), !0).forEach((function(t) {
                Se(e, t, n[t])
            }
            )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : _e(Object(n)).forEach((function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
            }
            ))
        }
        return e
    }
    function Se(e, t, n) {
        return (t = function(e) {
            var t = function(e, t) {
                if ("object" !== he(e) || null === e)
                    return e;
                var n = e[Symbol.toPrimitive];
                if (void 0 !== n) {
                    var r = n.call(e, t || "default");
                    if ("object" !== he(r))
                        return r;
                    throw new TypeError("@@toPrimitive must return a primitive value.")
                }
                return ("string" === t ? String : Number)(e)
            }(e, "string");
            return "symbol" === he(t) ? t : String(t)
        }(t))in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n,
        e
    }
    function je(e) {
        return je = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        }
        : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        }
        ,
        je(e)
    }
    function Pe(e) {
        return function(e) {
            if (Array.isArray(e))
                return we(e)
        }(e) || function(e) {
            if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"])
                return Array.from(e)
        }(e) || function(e, t) {
            if (!e)
                return;
            if ("string" == typeof e)
                return we(e, t);
            var n = Object.prototype.toString.call(e).slice(8, -1);
            "Object" === n && e.constructor && (n = e.constructor.name);
            if ("Map" === n || "Set" === n)
                return Array.from(e);
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
                return we(e, t)
        }(e) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }()
    }
    function we(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++)
            r[n] = e[n];
        return r
    }
    function Ie(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter((function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            }
            ))),
            n.push.apply(n, r)
        }
        return n
    }
    function Ae(e) {
        for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ie(Object(n), !0).forEach((function(t) {
                Ee(e, t, n[t])
            }
            )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ie(Object(n)).forEach((function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
            }
            ))
        }
        return e
    }
    function Ee(e, t, n) {
        return (t = function(e) {
            var t = function(e, t) {
                if ("object" !== je(e) || null === e)
                    return e;
                var n = e[Symbol.toPrimitive];
                if (void 0 !== n) {
                    var r = n.call(e, t || "default");
                    if ("object" !== je(r))
                        return r;
                    throw new TypeError("@@toPrimitive must return a primitive value.")
                }
                return ("string" === t ? String : Number)(e)
            }(e, "string");
            return "symbol" === je(t) ? t : String(t)
        }(t))in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n,
        e
    }
    function De(e, t) {
        var n, r = "undefined" != typeof window ? window : {}, o = e.plugins || [];
        return Ae(Ae({
            debug: !1,
            openOnFocus: !1,
            enterKeyHint: void 0,
            ignoreCompositionEvents: !1,
            placeholder: "",
            autoFocus: !1,
            defaultActiveItemId: null,
            stallThreshold: 300,
            insights: void 0,
            environment: r,
            shouldPanelOpen: function(e) {
                return b(e.state) > 0
            },
            reshape: function(e) {
                return e.sources
            }
        }, e), {}, {
            id: null !== (n = e.id) && void 0 !== n ? n : d(),
            plugins: o,
            initialState: Ae({
                activeItemId: null,
                query: "",
                completion: null,
                collections: [],
                isOpen: !1,
                status: "idle",
                context: {}
            }, e.initialState),
            onStateChange: function(t) {
                var n;
                null === (n = e.onStateChange) || void 0 === n || n.call(e, t),
                o.forEach((function(e) {
                    var n;
                    return null === (n = e.onStateChange) || void 0 === n ? void 0 : n.call(e, t)
                }
                ))
            },
            onSubmit: function(t) {
                var n;
                null === (n = e.onSubmit) || void 0 === n || n.call(e, t),
                o.forEach((function(e) {
                    var n;
                    return null === (n = e.onSubmit) || void 0 === n ? void 0 : n.call(e, t)
                }
                ))
            },
            onReset: function(t) {
                var n;
                null === (n = e.onReset) || void 0 === n || n.call(e, t),
                o.forEach((function(e) {
                    var n;
                    return null === (n = e.onReset) || void 0 === n ? void 0 : n.call(e, t)
                }
                ))
            },
            getSources: function(n) {
                return Promise.all([].concat(Pe(o.map((function(e) {
                    return e.getSources
                }
                ))), [e.getSources]).filter(Boolean).map((function(e) {
                    return function(e, t) {
                        var n = [];
                        return Promise.resolve(e(t)).then((function(e) {
                            return Promise.all(e.filter((function(e) {
                                return Boolean(e)
                            }
                            )).map((function(e) {
                                if (e.sourceId,
                                n.includes(e.sourceId))
                                    throw new Error("[Autocomplete] The `sourceId` ".concat(JSON.stringify(e.sourceId), " is not unique."));
                                n.push(e.sourceId);
                                var t = {
                                    getItemInputValue: function(e) {
                                        return e.state.query
                                    },
                                    getItemUrl: function() {},
                                    onSelect: function(e) {
                                        (0,
                                        e.setIsOpen)(!1)
                                    },
                                    onActive: _,
                                    onResolve: _
                                };
                                Object.keys(t).forEach((function(e) {
                                    t[e].__default = !0
                                }
                                ));
                                var r = ie(ie({}, t), e);
                                return Promise.resolve(r)
                            }
                            )))
                        }
                        ))
                    }(e, n)
                }
                ))).then((function(e) {
                    return m(e)
                }
                )).then((function(e) {
                    return e.map((function(e) {
                        return Ae(Ae({}, e), {}, {
                            onSelect: function(n) {
                                e.onSelect(n),
                                t.forEach((function(e) {
                                    var t;
                                    return null === (t = e.onSelect) || void 0 === t ? void 0 : t.call(e, n)
                                }
                                ))
                            },
                            onActive: function(n) {
                                e.onActive(n),
                                t.forEach((function(e) {
                                    var t;
                                    return null === (t = e.onActive) || void 0 === t ? void 0 : t.call(e, n)
                                }
                                ))
                            },
                            onResolve: function(n) {
                                e.onResolve(n),
                                t.forEach((function(e) {
                                    var t;
                                    return null === (t = e.onResolve) || void 0 === t ? void 0 : t.call(e, n)
                                }
                                ))
                            }
                        })
                    }
                    ))
                }
                ))
            },
            navigator: Ae({
                navigate: function(e) {
                    var t = e.itemUrl;
                    r.location.assign(t)
                },
                navigateNewTab: function(e) {
                    var t = e.itemUrl
                      , n = r.open(t, "_blank", "noopener");
                    null == n || n.focus()
                },
                navigateNewWindow: function(e) {
                    var t = e.itemUrl;
                    r.open(t, "_blank", "noopener")
                }
            }, e.navigator)
        })
    }
    function Ce(e) {
        return Ce = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        }
        : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        }
        ,
        Ce(e)
    }
    function ke(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter((function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            }
            ))),
            n.push.apply(n, r)
        }
        return n
    }
    function xe(e) {
        for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? ke(Object(n), !0).forEach((function(t) {
                Ne(e, t, n[t])
            }
            )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ke(Object(n)).forEach((function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
            }
            ))
        }
        return e
    }
    function Ne(e, t, n) {
        return (t = function(e) {
            var t = function(e, t) {
                if ("object" !== Ce(e) || null === e)
                    return e;
                var n = e[Symbol.toPrimitive];
                if (void 0 !== n) {
                    var r = n.call(e, t || "default");
                    if ("object" !== Ce(r))
                        return r;
                    throw new TypeError("@@toPrimitive must return a primitive value.")
                }
                return ("string" === t ? String : Number)(e)
            }(e, "string");
            return "symbol" === Ce(t) ? t : String(t)
        }(t))in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n,
        e
    }
    function Te(e) {
        return Te = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        }
        : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        }
        ,
        Te(e)
    }
    function qe(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter((function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            }
            ))),
            n.push.apply(n, r)
        }
        return n
    }
    function Be(e) {
        for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? qe(Object(n), !0).forEach((function(t) {
                Re(e, t, n[t])
            }
            )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : qe(Object(n)).forEach((function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
            }
            ))
        }
        return e
    }
    function Re(e, t, n) {
        return (t = function(e) {
            var t = function(e, t) {
                if ("object" !== Te(e) || null === e)
                    return e;
                var n = e[Symbol.toPrimitive];
                if (void 0 !== n) {
                    var r = n.call(e, t || "default");
                    if ("object" !== Te(r))
                        return r;
                    throw new TypeError("@@toPrimitive must return a primitive value.")
                }
                return ("string" === t ? String : Number)(e)
            }(e, "string");
            return "symbol" === Te(t) ? t : String(t)
        }(t))in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n,
        e
    }
    function Le(e) {
        return function(e) {
            if (Array.isArray(e))
                return Fe(e)
        }(e) || function(e) {
            if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"])
                return Array.from(e)
        }(e) || function(e, t) {
            if (!e)
                return;
            if ("string" == typeof e)
                return Fe(e, t);
            var n = Object.prototype.toString.call(e).slice(8, -1);
            "Object" === n && e.constructor && (n = e.constructor.name);
            if ("Map" === n || "Set" === n)
                return Array.from(e);
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
                return Fe(e, t)
        }(e) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }()
    }
    function Fe(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++)
            r[n] = e[n];
        return r
    }
    function Ue(e) {
        return Boolean(e.execute)
    }
    function Me(e, t, n) {
        if (o = e,
        Boolean(null == o ? void 0 : o.execute)) {
            var r = "algolia" === e.requesterId ? Object.assign.apply(Object, [{}].concat(Le(Object.keys(n.context).map((function(e) {
                var t;
                return null === (t = n.context[e]) || void 0 === t ? void 0 : t.__algoliaSearchParameters
            }
            ))))) : {};
            return Be(Be({}, e), {}, {
                requests: e.queries.map((function(n) {
                    return {
                        query: "algolia" === e.requesterId ? Be(Be({}, n), {}, {
                            params: Be(Be({}, r), n.params)
                        }) : n,
                        sourceId: t,
                        transformResponse: e.transformResponse
                    }
                }
                ))
            })
        }
        var o;
        return {
            items: e,
            sourceId: t
        }
    }
    function He(e) {
        var t = e.reduce((function(e, t) {
            if (!Ue(t))
                return e.push(t),
                e;
            var n = t.searchClient
              , r = t.execute
              , o = t.requesterId
              , i = t.requests
              , u = e.find((function(e) {
                return Ue(t) && Ue(e) && e.searchClient === n && Boolean(o) && e.requesterId === o
            }
            ));
            if (u) {
                var a;
                (a = u.items).push.apply(a, Le(i))
            } else {
                var l = {
                    execute: r,
                    requesterId: o,
                    items: i,
                    searchClient: n
                };
                e.push(l)
            }
            return e
        }
        ), []).map((function(e) {
            if (!Ue(e))
                return Promise.resolve(e);
            var t = e
              , n = t.execute
              , r = t.items;
            return n({
                searchClient: t.searchClient,
                requests: r
            })
        }
        ));
        return Promise.all(t).then((function(e) {
            return m(e)
        }
        ))
    }
    function Ve(e, t, n) {
        return t.map((function(t) {
            var r, o = e.filter((function(e) {
                return e.sourceId === t.sourceId
            }
            )), i = o.map((function(e) {
                return e.items
            }
            )), u = o[0].transformResponse, a = u ? u({
                results: r = i,
                hits: r.map((function(e) {
                    return e.hits
                }
                )).filter(Boolean),
                facetHits: r.map((function(e) {
                    var t;
                    return null === (t = e.facetHits) || void 0 === t ? void 0 : t.map((function(e) {
                        return {
                            label: e.value,
                            count: e.count,
                            _highlightResult: {
                                label: {
                                    value: e.highlighted
                                }
                            }
                        }
                    }
                    ))
                }
                )).filter(Boolean)
            }) : i;
            return t.onResolve({
                source: t,
                results: i,
                items: a,
                state: n.getState()
            }),
            a.every(Boolean),
            'The `getItems` function from source "'.concat(t.sourceId, '" must return an array of items but returned ').concat(JSON.stringify(void 0), ".\n\nDid you forget to return items?\n\nSee: https://www.algolia.com/doc/ui-libraries/autocomplete/core-concepts/sources/#param-getitems"),
            {
                source: t,
                items: a
            }
        }
        ))
    }
    function We(e) {
        return We = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        }
        : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        }
        ,
        We(e)
    }
    var Qe = ["event", "nextState", "props", "query", "refresh", "store"];
    function Ke(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter((function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            }
            ))),
            n.push.apply(n, r)
        }
        return n
    }
    function $e(e) {
        for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ke(Object(n), !0).forEach((function(t) {
                ze(e, t, n[t])
            }
            )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ke(Object(n)).forEach((function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
            }
            ))
        }
        return e
    }
    function ze(e, t, n) {
        return (t = function(e) {
            var t = function(e, t) {
                if ("object" !== We(e) || null === e)
                    return e;
                var n = e[Symbol.toPrimitive];
                if (void 0 !== n) {
                    var r = n.call(e, t || "default");
                    if ("object" !== We(r))
                        return r;
                    throw new TypeError("@@toPrimitive must return a primitive value.")
                }
                return ("string" === t ? String : Number)(e)
            }(e, "string");
            return "symbol" === We(t) ? t : String(t)
        }(t))in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n,
        e
    }
    function Ge(e, t) {
        if (null == e)
            return {};
        var n, r, o = function(e, t) {
            if (null == e)
                return {};
            var n, r, o = {}, i = Object.keys(e);
            for (r = 0; r < i.length; r++)
                n = i[r],
                t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o
        }(e, t);
        if (Object.getOwnPropertySymbols) {
            var i = Object.getOwnPropertySymbols(e);
            for (r = 0; r < i.length; r++)
                n = i[r],
                t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n])
        }
        return o
    }
    var Je, Xe, Ye, Ze = null, et = (Je = -1,
    Xe = -1,
    Ye = void 0,
    function(e) {
        var t = ++Je;
        return Promise.resolve(e).then((function(e) {
            return Ye && t < Xe ? Ye : (Xe = t,
            Ye = e,
            e)
        }
        ))
    }
    );
    function tt(e) {
        var t = e.event
          , n = e.nextState
          , r = void 0 === n ? {} : n
          , o = e.props
          , i = e.query
          , u = e.refresh
          , a = e.store
          , l = Ge(e, Qe);
        Ze && o.environment.clearTimeout(Ze);
        var c = l.setCollections
          , s = l.setIsOpen
          , f = l.setQuery
          , p = l.setActiveItemId
          , v = l.setStatus
          , d = l.setContext;
        if (f(i),
        p(o.defaultActiveItemId),
        !i && !1 === o.openOnFocus) {
            var y, b = a.getState().collections.map((function(e) {
                return $e($e({}, e), {}, {
                    items: []
                })
            }
            ));
            v("idle"),
            c(b),
            s(null !== (y = r.isOpen) && void 0 !== y ? y : o.shouldPanelOpen({
                state: a.getState()
            }));
            var g = Z(et(b).then((function() {
                return Promise.resolve()
            }
            )));
            return a.pendingRequests.add(g)
        }
        v("loading"),
        Ze = o.environment.setTimeout((function() {
            v("stalled")
        }
        ), o.stallThreshold);
        var h = Z(et(o.getSources($e({
            query: i,
            refresh: u,
            state: a.getState()
        }, l)).then((function(e) {
            return Promise.all(e.map((function(e) {
                return Promise.resolve(e.getItems($e({
                    query: i,
                    refresh: u,
                    state: a.getState()
                }, l))).then((function(t) {
                    return Me(t, e.sourceId, a.getState())
                }
                ))
            }
            ))).then(He).then((function(t) {
                var n, r = t.some((function(e) {
                    return function(e) {
                        return !Array.isArray(e) && Boolean(null == e ? void 0 : e._automaticInsights)
                    }(e.items)
                }
                ));
                r && d({
                    algoliaInsightsPlugin: $e($e({}, (null === (n = a.getState().context) || void 0 === n ? void 0 : n.algoliaInsightsPlugin) || {}), {}, {
                        __automaticInsights: r
                    })
                });
                return Ve(t, e, a)
            }
            )).then((function(e) {
                return function(e) {
                    var t = e.collections
                      , n = e.props
                      , r = e.state
                      , o = t.reduce((function(e, t) {
                        return xe(xe({}, e), {}, Ne({}, t.source.sourceId, xe(xe({}, t.source), {}, {
                            getItems: function() {
                                return m(t.items)
                            }
                        })))
                    }
                    ), {})
                      , i = n.plugins.reduce((function(e, t) {
                        return t.reshape ? t.reshape(e) : e
                    }
                    ), {
                        sourcesBySourceId: o,
                        state: r
                    }).sourcesBySourceId;
                    return m(n.reshape({
                        sourcesBySourceId: i,
                        sources: Object.values(i),
                        state: r
                    })).filter(Boolean).map((function(e) {
                        return {
                            source: e,
                            items: e.getItems()
                        }
                    }
                    ))
                }({
                    collections: e,
                    props: o,
                    state: a.getState()
                })
            }
            ))
        }
        )))).then((function(e) {
            var n;
            v("idle"),
            c(e);
            var f = o.shouldPanelOpen({
                state: a.getState()
            });
            s(null !== (n = r.isOpen) && void 0 !== n ? n : o.openOnFocus && !i && f || f);
            var p = fe(a.getState());
            if (null !== a.getState().activeItemId && p) {
                var m = p.item
                  , d = p.itemInputValue
                  , y = p.itemUrl
                  , b = p.source;
                b.onActive($e({
                    event: t,
                    item: m,
                    itemInputValue: d,
                    itemUrl: y,
                    refresh: u,
                    source: b,
                    state: a.getState()
                }, l))
            }
        }
        )).finally((function() {
            v("idle"),
            Ze && o.environment.clearTimeout(Ze)
        }
        ));
        return a.pendingRequests.add(h)
    }
    function nt(e) {
        return nt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        }
        : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        }
        ,
        nt(e)
    }
    var rt = ["event", "props", "refresh", "store"];
    function ot(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter((function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            }
            ))),
            n.push.apply(n, r)
        }
        return n
    }
    function it(e) {
        for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? ot(Object(n), !0).forEach((function(t) {
                ut(e, t, n[t])
            }
            )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ot(Object(n)).forEach((function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
            }
            ))
        }
        return e
    }
    function ut(e, t, n) {
        return (t = function(e) {
            var t = function(e, t) {
                if ("object" !== nt(e) || null === e)
                    return e;
                var n = e[Symbol.toPrimitive];
                if (void 0 !== n) {
                    var r = n.call(e, t || "default");
                    if ("object" !== nt(r))
                        return r;
                    throw new TypeError("@@toPrimitive must return a primitive value.")
                }
                return ("string" === t ? String : Number)(e)
            }(e, "string");
            return "symbol" === nt(t) ? t : String(t)
        }(t))in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n,
        e
    }
    function at(e, t) {
        if (null == e)
            return {};
        var n, r, o = function(e, t) {
            if (null == e)
                return {};
            var n, r, o = {}, i = Object.keys(e);
            for (r = 0; r < i.length; r++)
                n = i[r],
                t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o
        }(e, t);
        if (Object.getOwnPropertySymbols) {
            var i = Object.getOwnPropertySymbols(e);
            for (r = 0; r < i.length; r++)
                n = i[r],
                t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n])
        }
        return o
    }
    function lt(e) {
        return lt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        }
        : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        }
        ,
        lt(e)
    }
    var ct = ["props", "refresh", "store"]
      , st = ["inputElement", "formElement", "panelElement"]
      , ft = ["inputElement"]
      , pt = ["inputElement", "maxLength"]
      , mt = ["source"]
      , vt = ["item", "source"];
    function dt(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter((function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            }
            ))),
            n.push.apply(n, r)
        }
        return n
    }
    function yt(e) {
        for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? dt(Object(n), !0).forEach((function(t) {
                bt(e, t, n[t])
            }
            )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : dt(Object(n)).forEach((function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
            }
            ))
        }
        return e
    }
    function bt(e, t, n) {
        return (t = function(e) {
            var t = function(e, t) {
                if ("object" !== lt(e) || null === e)
                    return e;
                var n = e[Symbol.toPrimitive];
                if (void 0 !== n) {
                    var r = n.call(e, t || "default");
                    if ("object" !== lt(r))
                        return r;
                    throw new TypeError("@@toPrimitive must return a primitive value.")
                }
                return ("string" === t ? String : Number)(e)
            }(e, "string");
            return "symbol" === lt(t) ? t : String(t)
        }(t))in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n,
        e
    }
    function gt(e, t) {
        if (null == e)
            return {};
        var n, r, o = function(e, t) {
            if (null == e)
                return {};
            var n, r, o = {}, i = Object.keys(e);
            for (r = 0; r < i.length; r++)
                n = i[r],
                t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o
        }(e, t);
        if (Object.getOwnPropertySymbols) {
            var i = Object.getOwnPropertySymbols(e);
            for (r = 0; r < i.length; r++)
                n = i[r],
                t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n])
        }
        return o
    }
    function ht(e) {
        var t = e.props
          , n = e.refresh
          , r = e.store
          , o = gt(e, ct);
        return {
            getEnvironmentProps: function(e) {
                var n = e.inputElement
                  , o = e.formElement
                  , i = e.panelElement;
                function u(e) {
                    !r.getState().isOpen && r.pendingRequests.isEmpty() || e.target === n || !1 === [o, i].some((function(t) {
                        return n = t,
                        r = e.target,
                        n === r || n.contains(r);
                        var n, r
                    }
                    )) && (r.dispatch("blur", null),
                    t.debug || r.pendingRequests.cancelAll())
                }
                return yt({
                    onTouchStart: u,
                    onMouseDown: u,
                    onTouchMove: function(e) {
                        !1 !== r.getState().isOpen && n === t.environment.document.activeElement && e.target !== n && n.blur()
                    }
                }, gt(e, st))
            },
            getRootProps: function(e) {
                return yt({
                    role: "combobox",
                    "aria-expanded": r.getState().isOpen,
                    "aria-haspopup": "listbox",
                    "aria-controls": r.getState().isOpen ? r.getState().collections.map((function(e) {
                        var n = e.source;
                        return pe(t.id, "list", n)
                    }
                    )).join(" ") : void 0,
                    "aria-labelledby": pe(t.id, "label")
                }, e)
            },
            getFormProps: function(e) {
                e.inputElement;
                var i = gt(e, ft)
                  , u = function(i) {
                    var u;
                    t.onSubmit(yt({
                        event: i,
                        refresh: n,
                        state: r.getState()
                    }, o)),
                    r.dispatch("submit", null),
                    null === (u = e.inputElement) || void 0 === u || u.blur()
                };
                return yt({
                    action: "",
                    noValidate: !0,
                    role: "search",
                    onSubmit: function(e) {
                        e.preventDefault();
                        var n = se(t.plugins, r.pendingRequests);
                        void 0 !== n ? n.then((function() {
                            return u(e)
                        }
                        )) : u(e)
                    },
                    onReset: function(i) {
                        var u;
                        i.preventDefault(),
                        t.onReset(yt({
                            event: i,
                            refresh: n,
                            state: r.getState()
                        }, o)),
                        r.dispatch("reset", null),
                        null === (u = e.inputElement) || void 0 === u || u.focus()
                    }
                }, i)
            },
            getLabelProps: function(e) {
                return yt({
                    htmlFor: pe(t.id, "input"),
                    id: pe(t.id, "label")
                }, e)
            },
            getInputProps: function(e) {
                var i;
                function u(e) {
                    (t.openOnFocus || Boolean(r.getState().query)) && tt(yt({
                        event: e,
                        props: t,
                        query: r.getState().completion || r.getState().query,
                        refresh: n,
                        store: r
                    }, o)),
                    r.dispatch("focus", null)
                }
                var a = e || {};
                a.inputElement;
                var l = a.maxLength
                  , c = void 0 === l ? 512 : l
                  , s = gt(a, pt)
                  , f = fe(r.getState())
                  , p = function(e) {
                    return Boolean(e && e.match(me))
                }((null === (i = t.environment.navigator) || void 0 === i ? void 0 : i.userAgent) || "")
                  , m = t.enterKeyHint || (null != f && f.itemUrl && !p ? "go" : "search");
                return yt({
                    "aria-autocomplete": "both",
                    "aria-activedescendant": r.getState().isOpen && null !== r.getState().activeItemId ? pe(t.id, "item-".concat(r.getState().activeItemId), null == f ? void 0 : f.source) : void 0,
                    "aria-controls": r.getState().isOpen ? r.getState().collections.filter((function(e) {
                        return e.items.length > 0
                    }
                    )).map((function(e) {
                        var n = e.source;
                        return pe(t.id, "list", n)
                    }
                    )).join(" ") : void 0,
                    "aria-labelledby": pe(t.id, "label"),
                    value: r.getState().completion || r.getState().query,
                    id: pe(t.id, "input"),
                    autoComplete: "off",
                    autoCorrect: "off",
                    autoCapitalize: "off",
                    enterKeyHint: m,
                    spellCheck: "false",
                    autoFocus: t.autoFocus,
                    placeholder: t.placeholder,
                    maxLength: c,
                    type: "search",
                    onChange: function(e) {
                        var i = e.currentTarget.value;
                        t.ignoreCompositionEvents && ve(e).isComposing ? o.setQuery(i) : tt(yt({
                            event: e,
                            props: t,
                            query: i.slice(0, c),
                            refresh: n,
                            store: r
                        }, o))
                    },
                    onCompositionEnd: function(e) {
                        tt(yt({
                            event: e,
                            props: t,
                            query: e.currentTarget.value.slice(0, c),
                            refresh: n,
                            store: r
                        }, o))
                    },
                    onKeyDown: function(e) {
                        ve(e).isComposing || function(e) {
                            var t = e.event
                              , n = e.props
                              , r = e.refresh
                              , o = e.store
                              , i = at(e, rt);
                            if ("ArrowUp" === t.key || "ArrowDown" === t.key) {
                                var u = function() {
                                    var e = fe(o.getState())
                                      , t = n.environment.document.getElementById(pe(n.id, "item-".concat(o.getState().activeItemId), null == e ? void 0 : e.source));
                                    t && (t.scrollIntoViewIfNeeded ? t.scrollIntoViewIfNeeded(!1) : t.scrollIntoView(!1))
                                }
                                  , a = function() {
                                    var e = fe(o.getState());
                                    if (null !== o.getState().activeItemId && e) {
                                        var n = e.item
                                          , u = e.itemInputValue
                                          , a = e.itemUrl
                                          , l = e.source;
                                        l.onActive(it({
                                            event: t,
                                            item: n,
                                            itemInputValue: u,
                                            itemUrl: a,
                                            refresh: r,
                                            source: l,
                                            state: o.getState()
                                        }, i))
                                    }
                                };
                                t.preventDefault(),
                                !1 === o.getState().isOpen && (n.openOnFocus || Boolean(o.getState().query)) ? tt(it({
                                    event: t,
                                    props: n,
                                    query: o.getState().query,
                                    refresh: r,
                                    store: o
                                }, i)).then((function() {
                                    o.dispatch(t.key, {
                                        nextActiveItemId: n.defaultActiveItemId
                                    }),
                                    a(),
                                    setTimeout(u, 0)
                                }
                                )) : (o.dispatch(t.key, {}),
                                a(),
                                u())
                            } else if ("Escape" === t.key)
                                t.preventDefault(),
                                o.dispatch(t.key, null),
                                o.pendingRequests.cancelAll();
                            else if ("Tab" === t.key)
                                o.dispatch("blur", null),
                                o.pendingRequests.cancelAll();
                            else if ("Enter" === t.key) {
                                if (null === o.getState().activeItemId || o.getState().collections.every((function(e) {
                                    return 0 === e.items.length
                                }
                                ))) {
                                    var l = se(n.plugins, o.pendingRequests);
                                    return void (void 0 !== l ? l.then(o.pendingRequests.cancelAll) : n.debug || o.pendingRequests.cancelAll())
                                }
                                t.preventDefault();
                                var c = fe(o.getState())
                                  , s = c.item
                                  , f = c.itemInputValue
                                  , p = c.itemUrl
                                  , m = c.source;
                                if (t.metaKey || t.ctrlKey)
                                    void 0 !== p && (m.onSelect(it({
                                        event: t,
                                        item: s,
                                        itemInputValue: f,
                                        itemUrl: p,
                                        refresh: r,
                                        source: m,
                                        state: o.getState()
                                    }, i)),
                                    n.navigator.navigateNewTab({
                                        itemUrl: p,
                                        item: s,
                                        state: o.getState()
                                    }));
                                else if (t.shiftKey)
                                    void 0 !== p && (m.onSelect(it({
                                        event: t,
                                        item: s,
                                        itemInputValue: f,
                                        itemUrl: p,
                                        refresh: r,
                                        source: m,
                                        state: o.getState()
                                    }, i)),
                                    n.navigator.navigateNewWindow({
                                        itemUrl: p,
                                        item: s,
                                        state: o.getState()
                                    }));
                                else if (t.altKey)
                                    ;
                                else {
                                    if (void 0 !== p)
                                        return m.onSelect(it({
                                            event: t,
                                            item: s,
                                            itemInputValue: f,
                                            itemUrl: p,
                                            refresh: r,
                                            source: m,
                                            state: o.getState()
                                        }, i)),
                                        void n.navigator.navigate({
                                            itemUrl: p,
                                            item: s,
                                            state: o.getState()
                                        });
                                    tt(it({
                                        event: t,
                                        nextState: {
                                            isOpen: !1
                                        },
                                        props: n,
                                        query: f,
                                        refresh: r,
                                        store: o
                                    }, i)).then((function() {
                                        m.onSelect(it({
                                            event: t,
                                            item: s,
                                            itemInputValue: f,
                                            itemUrl: p,
                                            refresh: r,
                                            source: m,
                                            state: o.getState()
                                        }, i))
                                    }
                                    ))
                                }
                            }
                        }(yt({
                            event: e,
                            props: t,
                            refresh: n,
                            store: r
                        }, o))
                    },
                    onFocus: u,
                    onBlur: _,
                    onClick: function(n) {
                        e.inputElement !== t.environment.document.activeElement || r.getState().isOpen || u(n)
                    }
                }, s)
            },
            getPanelProps: function(e) {
                return yt({
                    onMouseDown: function(e) {
                        e.preventDefault()
                    },
                    onMouseLeave: function() {
                        r.dispatch("mouseleave", null)
                    }
                }, e)
            },
            getListProps: function(e) {
                var n = e || {}
                  , r = n.source
                  , o = gt(n, mt);
                return yt({
                    role: "listbox",
                    "aria-labelledby": pe(t.id, "label"),
                    id: pe(t.id, "list", r)
                }, o)
            },
            getItemProps: function(e) {
                var i = e.item
                  , u = e.source
                  , a = gt(e, vt);
                return yt({
                    id: pe(t.id, "item-".concat(i.__autocomplete_id), u),
                    role: "option",
                    "aria-selected": r.getState().activeItemId === i.__autocomplete_id,
                    onMouseMove: function(e) {
                        if (i.__autocomplete_id !== r.getState().activeItemId) {
                            r.dispatch("mousemove", i.__autocomplete_id);
                            var t = fe(r.getState());
                            if (null !== r.getState().activeItemId && t) {
                                var u = t.item
                                  , a = t.itemInputValue
                                  , l = t.itemUrl
                                  , c = t.source;
                                c.onActive(yt({
                                    event: e,
                                    item: u,
                                    itemInputValue: a,
                                    itemUrl: l,
                                    refresh: n,
                                    source: c,
                                    state: r.getState()
                                }, o))
                            }
                        }
                    },
                    onMouseDown: function(e) {
                        e.preventDefault()
                    },
                    onClick: function(e) {
                        var a = u.getItemInputValue({
                            item: i,
                            state: r.getState()
                        })
                          , l = u.getItemUrl({
                            item: i,
                            state: r.getState()
                        });
                        (l ? Promise.resolve() : tt(yt({
                            event: e,
                            nextState: {
                                isOpen: !1
                            },
                            props: t,
                            query: a,
                            refresh: n,
                            store: r
                        }, o))).then((function() {
                            u.onSelect(yt({
                                event: e,
                                item: i,
                                itemInputValue: a,
                                itemUrl: l,
                                refresh: n,
                                source: u,
                                state: r.getState()
                            }, o))
                        }
                        ))
                    }
                }, a)
            }
        }
    }
    function _t(e) {
        return _t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        }
        : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        }
        ,
        _t(e)
    }
    function Ot(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter((function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            }
            ))),
            n.push.apply(n, r)
        }
        return n
    }
    function St(e) {
        for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ot(Object(n), !0).forEach((function(t) {
                jt(e, t, n[t])
            }
            )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ot(Object(n)).forEach((function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
            }
            ))
        }
        return e
    }
    function jt(e, t, n) {
        return (t = function(e) {
            var t = function(e, t) {
                if ("object" !== _t(e) || null === e)
                    return e;
                var n = e[Symbol.toPrimitive];
                if (void 0 !== n) {
                    var r = n.call(e, t || "default");
                    if ("object" !== _t(r))
                        return r;
                    throw new TypeError("@@toPrimitive must return a primitive value.")
                }
                return ("string" === t ? String : Number)(e)
            }(e, "string");
            return "symbol" === _t(t) ? t : String(t)
        }(t))in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n,
        e
    }
    function Pt(e) {
        var t, n, r, o, i = e.plugins, u = e.options, a = null === (t = ((null === (n = u.__autocomplete_metadata) || void 0 === n ? void 0 : n.userAgents) || [])[0]) || void 0 === t ? void 0 : t.segment, l = a ? jt({}, a, Object.keys((null === (r = u.__autocomplete_metadata) || void 0 === r ? void 0 : r.options) || {})) : {};
        return {
            plugins: i.map((function(e) {
                return {
                    name: e.name,
                    options: Object.keys(e.__autocomplete_pluginOptions || [])
                }
            }
            )),
            options: St({
                "autocomplete-core": Object.keys(u)
            }, l),
            ua: S.concat((null === (o = u.__autocomplete_metadata) || void 0 === o ? void 0 : o.userAgents) || [])
        }
    }
    function wt(e) {
        var t, n = e.state;
        return !1 === n.isOpen || null === n.activeItemId ? null : (null === (t = fe(n)) || void 0 === t ? void 0 : t.itemInputValue) || null
    }
    function It(e) {
        return It = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        }
        : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        }
        ,
        It(e)
    }
    function At(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter((function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            }
            ))),
            n.push.apply(n, r)
        }
        return n
    }
    function Et(e) {
        for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? At(Object(n), !0).forEach((function(t) {
                Dt(e, t, n[t])
            }
            )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : At(Object(n)).forEach((function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
            }
            ))
        }
        return e
    }
    function Dt(e, t, n) {
        return (t = function(e) {
            var t = function(e, t) {
                if ("object" !== It(e) || null === e)
                    return e;
                var n = e[Symbol.toPrimitive];
                if (void 0 !== n) {
                    var r = n.call(e, t || "default");
                    if ("object" !== It(r))
                        return r;
                    throw new TypeError("@@toPrimitive must return a primitive value.")
                }
                return ("string" === t ? String : Number)(e)
            }(e, "string");
            return "symbol" === It(t) ? t : String(t)
        }(t))in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n,
        e
    }
    var Ct = function(e, t) {
        switch (t.type) {
        case "setActiveItemId":
        case "mousemove":
            return Et(Et({}, e), {}, {
                activeItemId: t.payload
            });
        case "setQuery":
            return Et(Et({}, e), {}, {
                query: t.payload,
                completion: null
            });
        case "setCollections":
            return Et(Et({}, e), {}, {
                collections: t.payload
            });
        case "setIsOpen":
            return Et(Et({}, e), {}, {
                isOpen: t.payload
            });
        case "setStatus":
            return Et(Et({}, e), {}, {
                status: t.payload
            });
        case "setContext":
            return Et(Et({}, e), {}, {
                context: Et(Et({}, e.context), t.payload)
            });
        case "ArrowDown":
            var n = Et(Et({}, e), {}, {
                activeItemId: t.payload.hasOwnProperty("nextActiveItemId") ? t.payload.nextActiveItemId : re(1, e.activeItemId, b(e), t.props.defaultActiveItemId)
            });
            return Et(Et({}, n), {}, {
                completion: wt({
                    state: n
                })
            });
        case "ArrowUp":
            var r = Et(Et({}, e), {}, {
                activeItemId: re(-1, e.activeItemId, b(e), t.props.defaultActiveItemId)
            });
            return Et(Et({}, r), {}, {
                completion: wt({
                    state: r
                })
            });
        case "Escape":
            return e.isOpen ? Et(Et({}, e), {}, {
                activeItemId: null,
                isOpen: !1,
                completion: null
            }) : Et(Et({}, e), {}, {
                activeItemId: null,
                query: "",
                status: "idle",
                collections: []
            });
        case "submit":
            return Et(Et({}, e), {}, {
                activeItemId: null,
                isOpen: !1,
                status: "idle"
            });
        case "reset":
            return Et(Et({}, e), {}, {
                activeItemId: !0 === t.props.openOnFocus ? t.props.defaultActiveItemId : null,
                status: "idle",
                completion: null,
                query: ""
            });
        case "focus":
            return Et(Et({}, e), {}, {
                activeItemId: t.props.defaultActiveItemId,
                isOpen: (t.props.openOnFocus || Boolean(e.query)) && t.props.shouldPanelOpen({
                    state: e
                })
            });
        case "blur":
            return t.props.debug ? e : Et(Et({}, e), {}, {
                isOpen: !1,
                activeItemId: null
            });
        case "mouseleave":
            return Et(Et({}, e), {}, {
                activeItemId: t.props.defaultActiveItemId
            });
        default:
            return "The reducer action ".concat(JSON.stringify(t.type), " is not supported."),
            e
        }
    };
    function kt(e) {
        return kt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        }
        : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        }
        ,
        kt(e)
    }
    function xt(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter((function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            }
            ))),
            n.push.apply(n, r)
        }
        return n
    }
    function Nt(e) {
        for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? xt(Object(n), !0).forEach((function(t) {
                Tt(e, t, n[t])
            }
            )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : xt(Object(n)).forEach((function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
            }
            ))
        }
        return e
    }
    function Tt(e, t, n) {
        return (t = function(e) {
            var t = function(e, t) {
                if ("object" !== kt(e) || null === e)
                    return e;
                var n = e[Symbol.toPrimitive];
                if (void 0 !== n) {
                    var r = n.call(e, t || "default");
                    if ("object" !== kt(r))
                        return r;
                    throw new TypeError("@@toPrimitive must return a primitive value.")
                }
                return ("string" === t ? String : Number)(e)
            }(e, "string");
            return "symbol" === kt(t) ? t : String(t)
        }(t))in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n,
        e
    }
    function qt(e) {
        var t = []
          , n = De(e, t)
          , r = ge(Ct, n, (function(e) {
            var t, r, i = e.prevState, c = e.state;
            if (n.onStateChange(Nt({
                prevState: i,
                state: c,
                refresh: u,
                navigator: n.navigator
            }, o)),
            !l() && null !== (t = c.context) && void 0 !== t && null !== (r = t.algoliaInsightsPlugin) && void 0 !== r && r.__automaticInsights && !1 !== n.insights) {
                var s = G({
                    __autocomplete_clickAnalytics: !1
                });
                n.plugins.push(s),
                a([s])
            }
        }
        ))
          , o = function(e) {
            var t = e.store;
            return {
                setActiveItemId: function(e) {
                    t.dispatch("setActiveItemId", e)
                },
                setQuery: function(e) {
                    t.dispatch("setQuery", e)
                },
                setCollections: function(e) {
                    var n = 0
                      , r = e.map((function(e) {
                        return Oe(Oe({}, e), {}, {
                            items: m(e.items).map((function(e) {
                                return Oe(Oe({}, e), {}, {
                                    __autocomplete_id: n++
                                })
                            }
                            ))
                        })
                    }
                    ));
                    t.dispatch("setCollections", r)
                },
                setIsOpen: function(e) {
                    t.dispatch("setIsOpen", e)
                },
                setStatus: function(e) {
                    t.dispatch("setStatus", e)
                },
                setContext: function(e) {
                    t.dispatch("setContext", e)
                }
            }
        }({
            store: r
        })
          , i = ht(Nt({
            props: n,
            refresh: u,
            store: r,
            navigator: n.navigator
        }, o));
        function u() {
            return tt(Nt({
                event: new Event("input"),
                nextState: {
                    isOpen: r.getState().isOpen
                },
                props: n,
                navigator: n.navigator,
                query: r.getState().query,
                refresh: u,
                store: r
            }, o))
        }
        function a(e) {
            e.forEach((function(e) {
                var r;
                return null === (r = e.subscribe) || void 0 === r ? void 0 : r.call(e, Nt(Nt({}, o), {}, {
                    navigator: n.navigator,
                    refresh: u,
                    onSelect: function(e) {
                        t.push({
                            onSelect: e
                        })
                    },
                    onActive: function(e) {
                        t.push({
                            onActive: e
                        })
                    },
                    onResolve: function(e) {
                        t.push({
                            onResolve: e
                        })
                    }
                }))
            }
            ))
        }
        function l() {
            return n.plugins.some((function(e) {
                return "aa.algoliaInsightsPlugin" === e.name
            }
            ))
        }
        if (n.insights && !l()) {
            var c = "boolean" == typeof n.insights ? {} : n.insights;
            n.plugins.push(G(c))
        }
        return a(n.plugins),
        function(e) {
            var t, n, r = e.metadata, o = e.environment;
            if (null === (t = o.navigator) || void 0 === t || null === (n = t.userAgent) || void 0 === n ? void 0 : n.includes("Algolia Crawler")) {
                var i = o.document.createElement("meta")
                  , u = o.document.querySelector("head");
                i.name = "algolia:metadata",
                setTimeout((function() {
                    i.content = JSON.stringify(r),
                    u.appendChild(i)
                }
                ), 0)
            }
        }({
            metadata: Pt({
                plugins: n.plugins,
                options: e
            }),
            environment: n.environment
        }),
        Nt(Nt({
            refresh: u,
            navigator: n.navigator
        }, i), o)
    }
    var Bt = function(e, t, n, r) {
        var o;
        t[0] = 0;
        for (var i = 1; i < t.length; i++) {
            var u = t[i++]
              , a = t[i] ? (t[0] |= u ? 1 : 2,
            n[t[i++]]) : t[++i];
            3 === u ? r[0] = a : 4 === u ? r[1] = Object.assign(r[1] || {}, a) : 5 === u ? (r[1] = r[1] || {})[t[++i]] = a : 6 === u ? r[1][t[++i]] += a + "" : u ? (o = e.apply(a, Bt(e, a, n, ["", null])),
            r.push(o),
            a[0] ? t[0] |= 2 : (t[i - 2] = 0,
            t[i] = o)) : r.push(a)
        }
        return r
    }
      , Rt = new Map;
    function Lt(e) {
        var t = Rt.get(this);
        return t || (t = new Map,
        Rt.set(this, t)),
        (t = Bt(this, t.get(e) || (t.set(e, t = function(e) {
            for (var t, n, r = 1, o = "", i = "", u = [0], a = function(e) {
                1 === r && (e || (o = o.replace(/^\s*\n\s*|\s*\n\s*$/g, ""))) ? u.push(0, e, o) : 3 === r && (e || o) ? (u.push(3, e, o),
                r = 2) : 2 === r && "..." === o && e ? u.push(4, e, 0) : 2 === r && o && !e ? u.push(5, 0, !0, o) : r >= 5 && ((o || !e && 5 === r) && (u.push(r, 0, o, n),
                r = 6),
                e && (u.push(r, e, 0, n),
                r = 6)),
                o = ""
            }, l = 0; l < e.length; l++) {
                l && (1 === r && a(),
                a(l));
                for (var c = 0; c < e[l].length; c++)
                    t = e[l][c],
                    1 === r ? "<" === t ? (a(),
                    u = [u],
                    r = 3) : o += t : 4 === r ? "--" === o && ">" === t ? (r = 1,
                    o = "") : o = t + o[0] : i ? t === i ? i = "" : o += t : '"' === t || "'" === t ? i = t : ">" === t ? (a(),
                    r = 1) : r && ("=" === t ? (r = 5,
                    n = o,
                    o = "") : "/" === t && (r < 5 || ">" === e[l][c + 1]) ? (a(),
                    3 === r && (u = u[0]),
                    r = u,
                    (u = u[0]).push(2, 0, r),
                    r = 0) : " " === t || "\t" === t || "\n" === t || "\r" === t ? (a(),
                    r = 2) : o += t),
                    3 === r && "!--" === o && (r = 4,
                    u = u[0])
            }
            return a(),
            u
        }(e)),
        t), arguments, [])).length > 1 ? t : t[0]
    }
    var Ft = function(e) {
        var t = e.environment
          , n = t.document.createElementNS("http://www.w3.org/2000/svg", "svg");
        n.setAttribute("class", "aa-ClearIcon"),
        n.setAttribute("viewBox", "0 0 24 24"),
        n.setAttribute("width", "18"),
        n.setAttribute("height", "18"),
        n.setAttribute("fill", "currentColor");
        var r = t.document.createElementNS("http://www.w3.org/2000/svg", "path");
        return r.setAttribute("d", "M5.293 6.707l5.293 5.293-5.293 5.293c-0.391 0.391-0.391 1.024 0 1.414s1.024 0.391 1.414 0l5.293-5.293 5.293 5.293c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414l-5.293-5.293 5.293-5.293c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0l-5.293 5.293-5.293-5.293c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414z"),
        n.appendChild(r),
        n
    };
    function Ut(e, t) {
        if ("string" == typeof t) {
            var n = e.document.querySelector(t);
            return "The element ".concat(JSON.stringify(t), " is not in the document."),
            n
        }
        return t
    }
    function Mt() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
            t[n] = arguments[n];
        return t.reduce((function(e, t) {
            return Object.keys(t).forEach((function(n) {
                var r = e[n]
                  , o = t[n];
                r !== o && (e[n] = [r, o].filter(Boolean).join(" "))
            }
            )),
            e
        }
        ), {})
    }
    var Ht = function(e) {
        return e && "object" === r(e) && "[object Object]" === Object.prototype.toString.call(e)
    };
    function Vt() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
            t[n] = arguments[n];
        return t.reduce((function(e, t) {
            return Object.keys(t).forEach((function(n) {
                var r = e[n]
                  , o = t[n];
                Array.isArray(r) && Array.isArray(o) ? e[n] = r.concat.apply(r, l(o)) : Ht(r) && Ht(o) ? e[n] = Vt(r, o) : e[n] = o
            }
            )),
            e
        }
        ), {})
    }
    function Wt(e, t) {
        return Object.entries(e).reduce((function(e, r) {
            var i = a(r, 2)
              , u = i[0]
              , l = i[1];
            return t({
                key: u,
                value: l
            }) ? n(n({}, e), {}, o({}, u, l)) : e
        }
        ), {})
    }
    var Qt = ["ontouchstart", "ontouchend", "ontouchmove", "ontouchcancel"];
    function Kt(e, t, n) {
        e[t] = null === n ? "" : "number" != typeof n ? n : n + "px"
    }
    function $t(e) {
        this._listeners[e.type](e)
    }
    function zt(e, t, n) {
        var r, o, i = e[t];
        if ("style" === t)
            if ("string" == typeof n)
                e.style = n;
            else if (null === n)
                e.style = "";
            else
                for (t in n)
                    i && n[t] === i[t] || Kt(e.style, t, n[t]);
        else
            "o" === t[0] && "n" === t[1] ? (r = t !== (t = t.replace(/Capture$/, "")),
            ((o = t.toLowerCase())in e || Qt.includes(o)) && (t = o),
            t = t.slice(2),
            e._listeners || (e._listeners = {}),
            e._listeners[t] = n,
            n ? i || e.addEventListener(t, $t, r) : e.removeEventListener(t, $t, r)) : "list" !== t && "tagName" !== t && "form" !== t && "type" !== t && "size" !== t && "download" !== t && "href" !== t && t in e ? e[t] = null == n ? "" : n : "function" != typeof n && "dangerouslySetInnerHTML" !== t && (null == n || !1 === n && !/^ar/.test(t) ? e.removeAttribute(t) : e.setAttribute(t, n))
    }
    function Gt(e) {
        switch (e) {
        case "onChange":
            return "onInput";
        case "onCompositionEnd":
            return "oncompositionend";
        default:
            return e
        }
    }
    function Jt(e, t) {
        for (var n in t)
            zt(e, Gt(n), t[n])
    }
    function Xt(e, t) {
        for (var n in t)
            "o" === n[0] && "n" === n[1] || zt(e, Gt(n), t[n])
    }
    var Yt = ["children"];
    function Zt(e) {
        return function(t, n) {
            var r = n.children
              , o = void 0 === r ? [] : r
              , i = u(n, Yt)
              , a = e.document.createElement(t);
            return Jt(a, i),
            a.append.apply(a, l(o)),
            a
        }
    }
    var en = ["autocompleteScopeApi", "environment", "classNames", "getInputProps", "getInputPropsCore", "isDetached", "state"]
      , tn = function(e) {
        var t = e.environment.document.createElementNS("http://www.w3.org/2000/svg", "svg");
        return t.setAttribute("class", "aa-LoadingIcon"),
        t.setAttribute("viewBox", "0 0 100 100"),
        t.setAttribute("width", "20"),
        t.setAttribute("height", "20"),
        t.innerHTML = '<circle\n  cx="50"\n  cy="50"\n  fill="none"\n  r="35"\n  stroke="currentColor"\n  stroke-dasharray="164.93361431346415 56.97787143782138"\n  stroke-width="6"\n>\n  <animateTransform\n    attributeName="transform"\n    type="rotate"\n    repeatCount="indefinite"\n    dur="1s"\n    values="0 50 50;90 50 50;180 50 50;360 50 50"\n    keyTimes="0;0.40;0.65;1"\n  />\n</circle>',
        t
    }
      , nn = function(e) {
        var t = e.environment
          , n = t.document.createElementNS("http://www.w3.org/2000/svg", "svg");
        n.setAttribute("class", "aa-SubmitIcon"),
        n.setAttribute("viewBox", "0 0 24 24"),
        n.setAttribute("width", "20"),
        n.setAttribute("height", "20"),
        n.setAttribute("fill", "currentColor");
        var r = t.document.createElementNS("http://www.w3.org/2000/svg", "path");
        return r.setAttribute("d", "M16.041 15.856c-0.034 0.026-0.067 0.055-0.099 0.087s-0.060 0.064-0.087 0.099c-1.258 1.213-2.969 1.958-4.855 1.958-1.933 0-3.682-0.782-4.95-2.050s-2.050-3.017-2.050-4.95 0.782-3.682 2.050-4.95 3.017-2.050 4.95-2.050 3.682 0.782 4.95 2.050 2.050 3.017 2.050 4.95c0 1.886-0.745 3.597-1.959 4.856zM21.707 20.293l-3.675-3.675c1.231-1.54 1.968-3.493 1.968-5.618 0-2.485-1.008-4.736-2.636-6.364s-3.879-2.636-6.364-2.636-4.736 1.008-6.364 2.636-2.636 3.879-2.636 6.364 1.008 4.736 2.636 6.364 3.879 2.636 6.364 2.636c2.125 0 4.078-0.737 5.618-1.968l3.675 3.675c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414z"),
        n.appendChild(r),
        n
    };
    function rn(e) {
        var t = e.autocomplete
          , r = e.autocompleteScopeApi
          , o = e.classNames
          , i = e.environment
          , a = e.isDetached
          , l = e.placeholder
          , c = void 0 === l ? "Search" : l
          , s = e.propGetters
          , f = e.setIsModalOpen
          , p = e.state
          , m = e.translations
          , v = Zt(i)
          , d = s.getRootProps(n({
            state: p,
            props: t.getRootProps({})
        }, r))
          , y = v("div", n({
            class: o.root
        }, d))
          , b = v("div", {
            class: o.detachedContainer,
            onMouseDown: function(e) {
                e.stopPropagation()
            }
        })
          , g = v("div", {
            class: o.detachedOverlay,
            children: [b],
            onMouseDown: function() {
                f(!1),
                t.setIsOpen(!1)
            }
        })
          , h = s.getLabelProps(n({
            state: p,
            props: t.getLabelProps({})
        }, r))
          , _ = v("button", {
            class: o.submitButton,
            type: "submit",
            title: m.submitButtonTitle,
            children: [nn({
                environment: i
            })]
        })
          , O = v("label", n({
            class: o.label,
            children: [_],
            ariaLabel: m.submitButtonTitle
        }, h))
          , S = v("button", {
            class: o.clearButton,
            type: "reset",
            title: m.clearButtonTitle,
            children: [Ft({
                environment: i
            })]
        })
          , j = v("div", {
            class: o.loadingIndicator,
            children: [tn({
                environment: i
            })]
        })
          , P = function(e) {
            var t = e.autocompleteScopeApi
              , r = e.environment;
            e.classNames;
            var o = e.getInputProps
              , i = e.getInputPropsCore
              , a = e.isDetached
              , l = e.state
              , c = u(e, en)
              , s = Zt(r)("input", c)
              , f = o(n({
                state: l,
                props: i({
                    inputElement: s
                }),
                inputElement: s
            }, t));
            return Jt(s, n(n({}, f), {}, {
                onKeyDown: function(e) {
                    a && "Tab" === e.key || f.onKeyDown(e)
                }
            })),
            s
        }({
            class: o.input,
            environment: i,
            state: p,
            getInputProps: s.getInputProps,
            getInputPropsCore: t.getInputProps,
            autocompleteScopeApi: r,
            isDetached: a
        })
          , w = v("div", {
            class: o.inputWrapperPrefix,
            children: [O, j]
        })
          , I = v("div", {
            class: o.inputWrapperSuffix,
            children: [S]
        })
          , A = v("div", {
            class: o.inputWrapper,
            children: [P]
        })
          , E = s.getFormProps(n({
            state: p,
            props: t.getFormProps({
                inputElement: P
            })
        }, r))
          , D = v("form", n({
            class: o.form,
            children: [w, A, I]
        }, E))
          , C = s.getPanelProps(n({
            state: p,
            props: t.getPanelProps({})
        }, r))
          , k = v("div", n({
            class: o.panel
        }, C))
          , x = v("div", {
            class: o.detachedSearchButtonQuery,
            textContent: p.query
        })
          , N = v("div", {
            class: o.detachedSearchButtonPlaceholder,
            hidden: Boolean(p.query),
            textContent: c
        });
        if (a) {
            var T = v("div", {
                class: o.detachedSearchButtonIcon,
                ariaLabel: m.detachedSearchButtonTitle,
                children: [nn({
                    environment: i
                })]
            })
              , q = v("button", {
                type: "button",
                class: o.detachedSearchButton,
                title: m.detachedSearchButtonTitle,
                id: h.id,
                onClick: function() {
                    f(!0)
                },
                children: [T, N, x]
            })
              , B = v("button", {
                type: "button",
                class: o.detachedCancelButton,
                textContent: m.detachedCancelButtonText,
                onTouchStart: function(e) {
                    e.stopPropagation()
                },
                onClick: function() {
                    t.setIsOpen(!1),
                    f(!1)
                }
            })
              , R = v("div", {
                class: o.detachedFormContainer,
                children: [D, B]
            });
            b.appendChild(R),
            y.appendChild(q)
        } else
            y.appendChild(D);
        return {
            detachedContainer: b,
            detachedOverlay: g,
            detachedSearchButtonQuery: x,
            detachedSearchButtonPlaceholder: N,
            inputWrapper: A,
            input: P,
            root: y,
            form: D,
            label: O,
            submitButton: _,
            clearButton: S,
            loadingIndicator: j,
            panel: k
        }
    }
    var on, un, an, ln, cn, sn, fn, pn = {}, mn = [], vn = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
    function dn(e, t) {
        for (var n in t)
            e[n] = t[n];
        return e
    }
    function yn(e) {
        var t = e.parentNode;
        t && t.removeChild(e)
    }
    function bn(e, t, n) {
        var r, o, i, u = {};
        for (i in t)
            "key" == i ? r = t[i] : "ref" == i ? o = t[i] : u[i] = t[i];
        if (arguments.length > 2 && (u.children = arguments.length > 3 ? on.call(arguments, 2) : n),
        "function" == typeof e && null != e.defaultProps)
            for (i in e.defaultProps)
                void 0 === u[i] && (u[i] = e.defaultProps[i]);
        return gn(e, u, r, o, null)
    }
    function gn(e, t, n, r, o) {
        var i = {
            type: e,
            props: t,
            key: n,
            ref: r,
            __k: null,
            __: null,
            __b: 0,
            __e: null,
            __d: void 0,
            __c: null,
            __h: null,
            constructor: void 0,
            __v: null == o ? ++an : o
        };
        return null == o && null != un.vnode && un.vnode(i),
        i
    }
    function hn(e) {
        return e.children
    }
    function _n(e, t) {
        this.props = e,
        this.context = t
    }
    function On(e, t) {
        if (null == t)
            return e.__ ? On(e.__, e.__.__k.indexOf(e) + 1) : null;
        for (var n; t < e.__k.length; t++)
            if (null != (n = e.__k[t]) && null != n.__e)
                return n.__e;
        return "function" == typeof e.type ? On(e) : null
    }
    function Sn(e) {
        var t, n;
        if (null != (e = e.__) && null != e.__c) {
            for (e.__e = e.__c.base = null,
            t = 0; t < e.__k.length; t++)
                if (null != (n = e.__k[t]) && null != n.__e) {
                    e.__e = e.__c.base = n.__e;
                    break
                }
            return Sn(e)
        }
    }
    function jn(e) {
        (!e.__d && (e.__d = !0) && ln.push(e) && !Pn.__r++ || cn !== un.debounceRendering) && ((cn = un.debounceRendering) || sn)(Pn)
    }
    function Pn() {
        var e, t, n, r, o, i, u, a;
        for (ln.sort(fn); e = ln.shift(); )
            e.__d && (t = ln.length,
            r = void 0,
            o = void 0,
            u = (i = (n = e).__v).__e,
            (a = n.__P) && (r = [],
            (o = dn({}, i)).__v = i.__v + 1,
            Nn(a, i, o, n.__n, void 0 !== a.ownerSVGElement, null != i.__h ? [u] : null, r, null == u ? On(i) : u, i.__h),
            Tn(r, i),
            i.__e != u && Sn(i)),
            ln.length > t && ln.sort(fn));
        Pn.__r = 0
    }
    function wn(e, t, n, r, o, i, u, a, l, c) {
        var s, f, p, m, v, d, y, b = r && r.__k || mn, g = b.length;
        for (n.__k = [],
        s = 0; s < t.length; s++)
            if (null != (m = n.__k[s] = null == (m = t[s]) || "boolean" == typeof m || "function" == typeof m ? null : "string" == typeof m || "number" == typeof m || "bigint" == typeof m ? gn(null, m, null, null, m) : Array.isArray(m) ? gn(hn, {
                children: m
            }, null, null, null) : m.__b > 0 ? gn(m.type, m.props, m.key, m.ref ? m.ref : null, m.__v) : m)) {
                if (m.__ = n,
                m.__b = n.__b + 1,
                null === (p = b[s]) || p && m.key == p.key && m.type === p.type)
                    b[s] = void 0;
                else
                    for (f = 0; f < g; f++) {
                        if ((p = b[f]) && m.key == p.key && m.type === p.type) {
                            b[f] = void 0;
                            break
                        }
                        p = null
                    }
                Nn(e, m, p = p || pn, o, i, u, a, l, c),
                v = m.__e,
                (f = m.ref) && p.ref != f && (y || (y = []),
                p.ref && y.push(p.ref, null, m),
                y.push(f, m.__c || v, m)),
                null != v ? (null == d && (d = v),
                "function" == typeof m.type && m.__k === p.__k ? m.__d = l = In(m, l, e) : l = An(e, m, p, b, v, l),
                "function" == typeof n.type && (n.__d = l)) : l && p.__e == l && l.parentNode != e && (l = On(p))
            }
        for (n.__e = d,
        s = g; s--; )
            null != b[s] && ("function" == typeof n.type && null != b[s].__e && b[s].__e == n.__d && (n.__d = En(r).nextSibling),
            Rn(b[s], b[s]));
        if (y)
            for (s = 0; s < y.length; s++)
                Bn(y[s], y[++s], y[++s])
    }
    function In(e, t, n) {
        for (var r, o = e.__k, i = 0; o && i < o.length; i++)
            (r = o[i]) && (r.__ = e,
            t = "function" == typeof r.type ? In(r, t, n) : An(n, r, r, o, r.__e, t));
        return t
    }
    function An(e, t, n, r, o, i) {
        var u, a, l;
        if (void 0 !== t.__d)
            u = t.__d,
            t.__d = void 0;
        else if (null == n || o != i || null == o.parentNode)
            e: if (null == i || i.parentNode !== e)
                e.appendChild(o),
                u = null;
            else {
                for (a = i,
                l = 0; (a = a.nextSibling) && l < r.length; l += 1)
                    if (a == o)
                        break e;
                e.insertBefore(o, i),
                u = i
            }
        return void 0 !== u ? u : o.nextSibling
    }
    function En(e) {
        var t, n, r;
        if (null == e.type || "string" == typeof e.type)
            return e.__e;
        if (e.__k)
            for (t = e.__k.length - 1; t >= 0; t--)
                if ((n = e.__k[t]) && (r = En(n)))
                    return r;
        return null
    }
    function Dn(e, t, n) {
        "-" === t[0] ? e.setProperty(t, null == n ? "" : n) : e[t] = null == n ? "" : "number" != typeof n || vn.test(t) ? n : n + "px"
    }
    function Cn(e, t, n, r, o) {
        var i;
        e: if ("style" === t)
            if ("string" == typeof n)
                e.style.cssText = n;
            else {
                if ("string" == typeof r && (e.style.cssText = r = ""),
                r)
                    for (t in r)
                        n && t in n || Dn(e.style, t, "");
                if (n)
                    for (t in n)
                        r && n[t] === r[t] || Dn(e.style, t, n[t])
            }
        else if ("o" === t[0] && "n" === t[1])
            i = t !== (t = t.replace(/Capture$/, "")),
            t = t.toLowerCase()in e ? t.toLowerCase().slice(2) : t.slice(2),
            e.l || (e.l = {}),
            e.l[t + i] = n,
            n ? r || e.addEventListener(t, i ? xn : kn, i) : e.removeEventListener(t, i ? xn : kn, i);
        else if ("dangerouslySetInnerHTML" !== t) {
            if (o)
                t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
            else if ("width" !== t && "height" !== t && "href" !== t && "list" !== t && "form" !== t && "tabIndex" !== t && "download" !== t && t in e)
                try {
                    e[t] = null == n ? "" : n;
                    break e
                } catch (e) {}
            "function" == typeof n || (null == n || !1 === n && "-" !== t[4] ? e.removeAttribute(t) : e.setAttribute(t, n))
        }
    }
    function kn(e) {
        return this.l[e.type + !1](un.event ? un.event(e) : e)
    }
    function xn(e) {
        return this.l[e.type + !0](un.event ? un.event(e) : e)
    }
    function Nn(e, t, n, r, o, i, u, a, l) {
        var c, s, f, p, m, v, d, y, b, g, h, _, O, S, j, P = t.type;
        if (void 0 !== t.constructor)
            return null;
        null != n.__h && (l = n.__h,
        a = t.__e = n.__e,
        t.__h = null,
        i = [a]),
        (c = un.__b) && c(t);
        try {
            e: if ("function" == typeof P) {
                if (y = t.props,
                b = (c = P.contextType) && r[c.__c],
                g = c ? b ? b.props.value : c.__ : r,
                n.__c ? d = (s = t.__c = n.__c).__ = s.__E : ("prototype"in P && P.prototype.render ? t.__c = s = new P(y,g) : (t.__c = s = new _n(y,g),
                s.constructor = P,
                s.render = Ln),
                b && b.sub(s),
                s.props = y,
                s.state || (s.state = {}),
                s.context = g,
                s.__n = r,
                f = s.__d = !0,
                s.__h = [],
                s._sb = []),
                null == s.__s && (s.__s = s.state),
                null != P.getDerivedStateFromProps && (s.__s == s.state && (s.__s = dn({}, s.__s)),
                dn(s.__s, P.getDerivedStateFromProps(y, s.__s))),
                p = s.props,
                m = s.state,
                s.__v = t,
                f)
                    null == P.getDerivedStateFromProps && null != s.componentWillMount && s.componentWillMount(),
                    null != s.componentDidMount && s.__h.push(s.componentDidMount);
                else {
                    if (null == P.getDerivedStateFromProps && y !== p && null != s.componentWillReceiveProps && s.componentWillReceiveProps(y, g),
                    !s.__e && null != s.shouldComponentUpdate && !1 === s.shouldComponentUpdate(y, s.__s, g) || t.__v === n.__v) {
                        for (t.__v !== n.__v && (s.props = y,
                        s.state = s.__s,
                        s.__d = !1),
                        s.__e = !1,
                        t.__e = n.__e,
                        t.__k = n.__k,
                        t.__k.forEach((function(e) {
                            e && (e.__ = t)
                        }
                        )),
                        h = 0; h < s._sb.length; h++)
                            s.__h.push(s._sb[h]);
                        s._sb = [],
                        s.__h.length && u.push(s);
                        break e
                    }
                    null != s.componentWillUpdate && s.componentWillUpdate(y, s.__s, g),
                    null != s.componentDidUpdate && s.__h.push((function() {
                        s.componentDidUpdate(p, m, v)
                    }
                    ))
                }
                if (s.context = g,
                s.props = y,
                s.__P = e,
                _ = un.__r,
                O = 0,
                "prototype"in P && P.prototype.render) {
                    for (s.state = s.__s,
                    s.__d = !1,
                    _ && _(t),
                    c = s.render(s.props, s.state, s.context),
                    S = 0; S < s._sb.length; S++)
                        s.__h.push(s._sb[S]);
                    s._sb = []
                } else
                    do {
                        s.__d = !1,
                        _ && _(t),
                        c = s.render(s.props, s.state, s.context),
                        s.state = s.__s
                    } while (s.__d && ++O < 25);
                s.state = s.__s,
                null != s.getChildContext && (r = dn(dn({}, r), s.getChildContext())),
                f || null == s.getSnapshotBeforeUpdate || (v = s.getSnapshotBeforeUpdate(p, m)),
                j = null != c && c.type === hn && null == c.key ? c.props.children : c,
                wn(e, Array.isArray(j) ? j : [j], t, n, r, o, i, u, a, l),
                s.base = t.__e,
                t.__h = null,
                s.__h.length && u.push(s),
                d && (s.__E = s.__ = null),
                s.__e = !1
            } else
                null == i && t.__v === n.__v ? (t.__k = n.__k,
                t.__e = n.__e) : t.__e = qn(n.__e, t, n, r, o, i, u, l);
            (c = un.diffed) && c(t)
        } catch (e) {
            t.__v = null,
            (l || null != i) && (t.__e = a,
            t.__h = !!l,
            i[i.indexOf(a)] = null),
            un.__e(e, t, n)
        }
    }
    function Tn(e, t) {
        un.__c && un.__c(t, e),
        e.some((function(t) {
            try {
                e = t.__h,
                t.__h = [],
                e.some((function(e) {
                    e.call(t)
                }
                ))
            } catch (e) {
                un.__e(e, t.__v)
            }
        }
        ))
    }
    function qn(e, t, n, r, o, i, u, a) {
        var l, c, s, f = n.props, p = t.props, m = t.type, v = 0;
        if ("svg" === m && (o = !0),
        null != i)
            for (; v < i.length; v++)
                if ((l = i[v]) && "setAttribute"in l == !!m && (m ? l.localName === m : 3 === l.nodeType)) {
                    e = l,
                    i[v] = null;
                    break
                }
        if (null == e) {
            if (null === m)
                return document.createTextNode(p);
            e = o ? document.createElementNS("http://www.w3.org/2000/svg", m) : document.createElement(m, p.is && p),
            i = null,
            a = !1
        }
        if (null === m)
            f === p || a && e.data === p || (e.data = p);
        else {
            if (i = i && on.call(e.childNodes),
            c = (f = n.props || pn).dangerouslySetInnerHTML,
            s = p.dangerouslySetInnerHTML,
            !a) {
                if (null != i)
                    for (f = {},
                    v = 0; v < e.attributes.length; v++)
                        f[e.attributes[v].name] = e.attributes[v].value;
                (s || c) && (s && (c && s.__html == c.__html || s.__html === e.innerHTML) || (e.innerHTML = s && s.__html || ""))
            }
            if (function(e, t, n, r, o) {
                var i;
                for (i in n)
                    "children" === i || "key" === i || i in t || Cn(e, i, null, n[i], r);
                for (i in t)
                    o && "function" != typeof t[i] || "children" === i || "key" === i || "value" === i || "checked" === i || n[i] === t[i] || Cn(e, i, t[i], n[i], r)
            }(e, p, f, o, a),
            s)
                t.__k = [];
            else if (v = t.props.children,
            wn(e, Array.isArray(v) ? v : [v], t, n, r, o && "foreignObject" !== m, i, u, i ? i[0] : n.__k && On(n, 0), a),
            null != i)
                for (v = i.length; v--; )
                    null != i[v] && yn(i[v]);
            a || ("value"in p && void 0 !== (v = p.value) && (v !== e.value || "progress" === m && !v || "option" === m && v !== f.value) && Cn(e, "value", v, f.value, !1),
            "checked"in p && void 0 !== (v = p.checked) && v !== e.checked && Cn(e, "checked", v, f.checked, !1))
        }
        return e
    }
    function Bn(e, t, n) {
        try {
            "function" == typeof e ? e(t) : e.current = t
        } catch (e) {
            un.__e(e, n)
        }
    }
    function Rn(e, t, n) {
        var r, o;
        if (un.unmount && un.unmount(e),
        (r = e.ref) && (r.current && r.current !== e.__e || Bn(r, null, t)),
        null != (r = e.__c)) {
            if (r.componentWillUnmount)
                try {
                    r.componentWillUnmount()
                } catch (e) {
                    un.__e(e, t)
                }
            r.base = r.__P = null,
            e.__c = void 0
        }
        if (r = e.__k)
            for (o = 0; o < r.length; o++)
                r[o] && Rn(r[o], t, n || "function" != typeof e.type);
        n || null == e.__e || yn(e.__e),
        e.__ = e.__e = e.__d = void 0
    }
    function Ln(e, t, n) {
        return this.constructor(e, n)
    }
    on = mn.slice,
    un = {
        __e: function(e, t, n, r) {
            for (var o, i, u; t = t.__; )
                if ((o = t.__c) && !o.__)
                    try {
                        if ((i = o.constructor) && null != i.getDerivedStateFromError && (o.setState(i.getDerivedStateFromError(e)),
                        u = o.__d),
                        null != o.componentDidCatch && (o.componentDidCatch(e, r || {}),
                        u = o.__d),
                        u)
                            return o.__E = o
                    } catch (t) {
                        e = t
                    }
            throw e
        }
    },
    an = 0,
    _n.prototype.setState = function(e, t) {
        var n;
        n = null != this.__s && this.__s !== this.state ? this.__s : this.__s = dn({}, this.state),
        "function" == typeof e && (e = e(dn({}, n), this.props)),
        e && dn(n, e),
        null != e && this.__v && (t && this._sb.push(t),
        jn(this))
    }
    ,
    _n.prototype.forceUpdate = function(e) {
        this.__v && (this.__e = !0,
        e && this.__h.push(e),
        jn(this))
    }
    ,
    _n.prototype.render = hn,
    ln = [],
    sn = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout,
    fn = function(e, t) {
        return e.__v.__b - t.__v.__b
    }
    ,
    Pn.__r = 0;
    var Fn = "__aa-highlight__"
      , Un = "__/aa-highlight__";
    function Mn(e) {
        var t = e.highlightedValue.split(Fn)
          , n = t.shift()
          , r = function() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
            return {
                get: function() {
                    return e
                },
                add: function(t) {
                    var n = e[e.length - 1];
                    (null == n ? void 0 : n.isHighlighted) === t.isHighlighted ? e[e.length - 1] = {
                        value: n.value + t.value,
                        isHighlighted: n.isHighlighted
                    } : e.push(t)
                }
            }
        }(n ? [{
            value: n,
            isHighlighted: !1
        }] : []);
        return t.forEach((function(e) {
            var t = e.split(Un);
            r.add({
                value: t[0],
                isHighlighted: !0
            }),
            "" !== t[1] && r.add({
                value: t[1],
                isHighlighted: !1
            })
        }
        )),
        r.get()
    }
    function Hn(e) {
        return function(e) {
            if (Array.isArray(e))
                return Vn(e)
        }(e) || function(e) {
            if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"])
                return Array.from(e)
        }(e) || function(e, t) {
            if (!e)
                return;
            if ("string" == typeof e)
                return Vn(e, t);
            var n = Object.prototype.toString.call(e).slice(8, -1);
            "Object" === n && e.constructor && (n = e.constructor.name);
            if ("Map" === n || "Set" === n)
                return Array.from(e);
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
                return Vn(e, t)
        }(e) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }()
    }
    function Vn(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++)
            r[n] = e[n];
        return r
    }
    function Wn(e) {
        var t = e.hit
          , n = e.attribute
          , r = Array.isArray(n) ? n : [n]
          , o = y(t, ["_highlightResult"].concat(Hn(r), ["value"]));
        return "string" != typeof o && (o = y(t, r) || ""),
        Mn({
            highlightedValue: o
        })
    }
    var Qn = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    }
      , Kn = new RegExp(/\w/i)
      , $n = /&(amp|quot|lt|gt|#39);/g
      , zn = RegExp($n.source);
    function Gn(e, t) {
        var n, r, o, i = e[t], u = (null === (n = e[t + 1]) || void 0 === n ? void 0 : n.isHighlighted) || !0, a = (null === (r = e[t - 1]) || void 0 === r ? void 0 : r.isHighlighted) || !0;
        return Kn.test((o = i.value) && zn.test(o) ? o.replace($n, (function(e) {
            return Qn[e]
        }
        )) : o) || a !== u ? i.isHighlighted : a
    }
    function Jn(e) {
        return Jn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        }
        : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        }
        ,
        Jn(e)
    }
    function Xn(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter((function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            }
            ))),
            n.push.apply(n, r)
        }
        return n
    }
    function Yn(e) {
        for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Xn(Object(n), !0).forEach((function(t) {
                Zn(e, t, n[t])
            }
            )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Xn(Object(n)).forEach((function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
            }
            ))
        }
        return e
    }
    function Zn(e, t, n) {
        return (t = function(e) {
            var t = function(e, t) {
                if ("object" !== Jn(e) || null === e)
                    return e;
                var n = e[Symbol.toPrimitive];
                if (void 0 !== n) {
                    var r = n.call(e, t || "default");
                    if ("object" !== Jn(r))
                        return r;
                    throw new TypeError("@@toPrimitive must return a primitive value.")
                }
                return ("string" === t ? String : Number)(e)
            }(e, "string");
            return "symbol" === Jn(t) ? t : String(t)
        }(t))in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n,
        e
    }
    function er(e) {
        return e.some((function(e) {
            return e.isHighlighted
        }
        )) ? e.map((function(t, n) {
            return Yn(Yn({}, t), {}, {
                isHighlighted: !Gn(e, n)
            })
        }
        )) : e.map((function(e) {
            return Yn(Yn({}, e), {}, {
                isHighlighted: !1
            })
        }
        ))
    }
    function tr(e) {
        return function(e) {
            if (Array.isArray(e))
                return nr(e)
        }(e) || function(e) {
            if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"])
                return Array.from(e)
        }(e) || function(e, t) {
            if (!e)
                return;
            if ("string" == typeof e)
                return nr(e, t);
            var n = Object.prototype.toString.call(e).slice(8, -1);
            "Object" === n && e.constructor && (n = e.constructor.name);
            if ("Map" === n || "Set" === n)
                return Array.from(e);
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
                return nr(e, t)
        }(e) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }()
    }
    function nr(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++)
            r[n] = e[n];
        return r
    }
    function rr(e) {
        var t = e.hit
          , n = e.attribute
          , r = Array.isArray(n) ? n : [n]
          , o = y(t, ["_snippetResult"].concat(tr(r), ["value"]));
        return "string" != typeof o && (o = y(t, r) || ""),
        Mn({
            highlightedValue: o
        })
    }
    function or(e) {
        return or = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        }
        : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        }
        ,
        or(e)
    }
    function ir(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter((function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            }
            ))),
            n.push.apply(n, r)
        }
        return n
    }
    function ur(e) {
        for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? ir(Object(n), !0).forEach((function(t) {
                ar(e, t, n[t])
            }
            )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ir(Object(n)).forEach((function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
            }
            ))
        }
        return e
    }
    function ar(e, t, n) {
        return (t = function(e) {
            var t = function(e, t) {
                if ("object" !== or(e) || null === e)
                    return e;
                var n = e[Symbol.toPrimitive];
                if (void 0 !== n) {
                    var r = n.call(e, t || "default");
                    if ("object" !== or(r))
                        return r;
                    throw new TypeError("@@toPrimitive must return a primitive value.")
                }
                return ("string" === t ? String : Number)(e)
            }(e, "string");
            return "symbol" === or(t) ? t : String(t)
        }(t))in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n,
        e
    }
    function lr(e) {
        return lr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        }
        : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        }
        ,
        lr(e)
    }
    var cr = ["params"];
    function sr(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter((function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            }
            ))),
            n.push.apply(n, r)
        }
        return n
    }
    function fr(e) {
        for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? sr(Object(n), !0).forEach((function(t) {
                pr(e, t, n[t])
            }
            )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : sr(Object(n)).forEach((function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t))
            }
            ))
        }
        return e
    }
    function pr(e, t, n) {
        return (t = function(e) {
            var t = function(e, t) {
                if ("object" !== lr(e) || null === e)
                    return e;
                var n = e[Symbol.toPrimitive];
                if (void 0 !== n) {
                    var r = n.call(e, t || "default");
                    if ("object" !== lr(r))
                        return r;
                    throw new TypeError("@@toPrimitive must return a primitive value.")
                }
                return ("string" === t ? String : Number)(e)
            }(e, "string");
            return "symbol" === lr(t) ? t : String(t)
        }(t))in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n,
        e
    }
    function mr(e, t) {
        if (null == e)
            return {};
        var n, r, o = function(e, t) {
            if (null == e)
                return {};
            var n, r, o = {}, i = Object.keys(e);
            for (r = 0; r < i.length; r++)
                n = i[r],
                t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o
        }(e, t);
        if (Object.getOwnPropertySymbols) {
            var i = Object.getOwnPropertySymbols(e);
            for (r = 0; r < i.length; r++)
                n = i[r],
                t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n])
        }
        return o
    }
    function vr(e) {
        return function(e) {
            if (Array.isArray(e))
                return dr(e)
        }(e) || function(e) {
            if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"])
                return Array.from(e)
        }(e) || function(e, t) {
            if (!e)
                return;
            if ("string" == typeof e)
                return dr(e, t);
            var n = Object.prototype.toString.call(e).slice(8, -1);
            "Object" === n && e.constructor && (n = e.constructor.name);
            if ("Map" === n || "Set" === n)
                return Array.from(e);
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
                return dr(e, t)
        }(e) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }()
    }
    function dr(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++)
            r[n] = e[n];
        return r
    }
    function yr(e) {
        var t = e.createElement
          , n = e.Fragment;
        function r(e) {
            var r = e.hit
              , o = e.attribute
              , i = e.tagName
              , u = void 0 === i ? "mark" : i;
            return t(n, {}, Wn({
                hit: r,
                attribute: o
            }).map((function(e, n) {
                return e.isHighlighted ? t(u, {
                    key: n
                }, e.value) : e.value
            }
            )))
        }
        return r.__autocomplete_componentName = "Highlight",
        r
    }
    function br(e) {
        var t = e.createElement
          , n = e.Fragment;
        function r(e) {
            var r, o = e.hit, i = e.attribute, u = e.tagName, a = void 0 === u ? "mark" : u;
            return t(n, {}, (r = {
                hit: o,
                attribute: i
            },
            er(Wn(r))).map((function(e, n) {
                return e.isHighlighted ? t(a, {
                    key: n
                }, e.value) : e.value
            }
            )))
        }
        return r.__autocomplete_componentName = "ReverseHighlight",
        r
    }
    function gr(e) {
        var t = e.createElement
          , n = e.Fragment;
        function r(e) {
            var r, o = e.hit, i = e.attribute, u = e.tagName, a = void 0 === u ? "mark" : u;
            return t(n, {}, (r = {
                hit: o,
                attribute: i
            },
            er(rr(r))).map((function(e, n) {
                return e.isHighlighted ? t(a, {
                    key: n
                }, e.value) : e.value
            }
            )))
        }
        return r.__autocomplete_componentName = "ReverseSnippet",
        r
    }
    function hr(e) {
        var t = e.createElement
          , n = e.Fragment;
        function r(e) {
            var r = e.hit
              , o = e.attribute
              , i = e.tagName
              , u = void 0 === i ? "mark" : i;
            return t(n, {}, rr({
                hit: r,
                attribute: o
            }).map((function(e, n) {
                return e.isHighlighted ? t(u, {
                    key: n
                }, e.value) : e.value
            }
            )))
        }
        return r.__autocomplete_componentName = "Snippet",
        r
    }
    var _r = ["classNames", "container", "getEnvironmentProps", "getFormProps", "getInputProps", "getItemProps", "getLabelProps", "getListProps", "getPanelProps", "getRootProps", "panelContainer", "panelPlacement", "render", "renderNoResults", "renderer", "detachedMediaQuery", "components", "translations"]
      , Or = {
        clearButton: "aa-ClearButton",
        detachedCancelButton: "aa-DetachedCancelButton",
        detachedContainer: "aa-DetachedContainer",
        detachedFormContainer: "aa-DetachedFormContainer",
        detachedOverlay: "aa-DetachedOverlay",
        detachedSearchButton: "aa-DetachedSearchButton",
        detachedSearchButtonIcon: "aa-DetachedSearchButtonIcon",
        detachedSearchButtonPlaceholder: "aa-DetachedSearchButtonPlaceholder",
        detachedSearchButtonQuery: "aa-DetachedSearchButtonQuery",
        form: "aa-Form",
        input: "aa-Input",
        inputWrapper: "aa-InputWrapper",
        inputWrapperPrefix: "aa-InputWrapperPrefix",
        inputWrapperSuffix: "aa-InputWrapperSuffix",
        item: "aa-Item",
        label: "aa-Label",
        list: "aa-List",
        loadingIndicator: "aa-LoadingIndicator",
        panel: "aa-Panel",
        panelLayout: "aa-PanelLayout aa-Panel--scrollable",
        root: "aa-Autocomplete",
        source: "aa-Source",
        sourceFooter: "aa-SourceFooter",
        sourceHeader: "aa-SourceHeader",
        sourceNoResults: "aa-SourceNoResults",
        submitButton: "aa-SubmitButton"
    }
      , Sr = function(e, t) {
        var n = e.children;
        (0,
        e.render)(n, t)
    }
      , jr = {
        createElement: bn,
        Fragment: hn,
        render: function(e, t, n) {
            var r, o, i;
            un.__ && un.__(e, t),
            o = (r = "function" == typeof n) ? null : n && n.__k || t.__k,
            i = [],
            Nn(t, e = (!r && n || t).__k = bn(hn, null, [e]), o || pn, pn, void 0 !== t.ownerSVGElement, !r && n ? [n] : o ? null : t.firstChild ? on.call(t.childNodes) : null, i, !r && n ? n : o ? o.__e : t.firstChild, r),
            Tn(i, e)
        }
    };
    function Pr(e) {
        var t = e.panelPlacement
          , n = e.container
          , r = e.form
          , o = e.environment
          , i = n.getBoundingClientRect()
          , u = (o.pageYOffset || o.document.documentElement.scrollTop || o.document.body.scrollTop || 0) + i.top + i.height;
        switch (t) {
        case "start":
            return {
                top: u,
                left: i.left
            };
        case "end":
            return {
                top: u,
                right: o.document.documentElement.clientWidth - (i.left + i.width)
            };
        case "full-width":
            return {
                top: u,
                left: 0,
                right: 0,
                width: "unset",
                maxWidth: "unset"
            };
        case "input-wrapper-width":
            var a = r.getBoundingClientRect();
            return {
                top: u,
                left: a.left,
                right: o.document.documentElement.clientWidth - (a.left + a.width),
                width: "unset",
                maxWidth: "unset"
            };
        default:
            throw new Error("[Autocomplete] The `panelPlacement` value ".concat(JSON.stringify(t), " is not valid."))
        }
    }
    var wr = [{
        segment: "autocomplete-js",
        version: O
    }]
      , Ir = ["components"];
    var Ar = function(e, t) {
        function n(t) {
            return e({
                searchClient: t.searchClient,
                queries: t.requests.map((function(e) {
                    return e.query
                }
                ))
            }).then((function(e) {
                return e.map((function(e, n) {
                    var r = t.requests[n];
                    return {
                        items: e,
                        sourceId: r.sourceId,
                        transformResponse: r.transformResponse
                    }
                }
                ))
            }
            ))
        }
        return function(e) {
            return function(r) {
                return ur(ur({
                    requesterId: t,
                    execute: n
                }, e), r)
            }
        }
    }((function(e) {
        return function(e) {
            var t = e.searchClient
              , n = e.queries
              , r = e.userAgents
              , o = void 0 === r ? [] : r;
            "function" == typeof t.addAlgoliaAgent && [].concat(vr(S), vr(o)).forEach((function(e) {
                var n = e.segment
                  , r = e.version;
                t.addAlgoliaAgent(n, r)
            }
            ));
            var i = function(e) {
                var t = e.transporter || {}
                  , n = t.headers || t.baseHeaders || {}
                  , r = t.queryParameters || t.baseQueryParameters || {}
                  , o = "x-algolia-application-id"
                  , i = "x-algolia-api-key";
                return {
                    appId: n[o] || r[o],
                    apiKey: n[i] || r[i]
                }
            }(t)
              , u = i.appId
              , a = i.apiKey;
            return t.search(n.map((function(e) {
                var t = e.params;
                return fr(fr({}, mr(e, cr)), {}, {
                    params: fr({
                        hitsPerPage: 5,
                        highlightPreTag: Fn,
                        highlightPostTag: Un
                    }, t)
                })
            }
            ))).then((function(e) {
                return e.results.map((function(e, t) {
                    var r;
                    return fr(fr({}, e), {}, {
                        hits: null === (r = e.hits) || void 0 === r ? void 0 : r.map((function(r) {
                            return fr(fr({}, r), {}, {
                                __autocomplete_indexName: e.index || n[t].indexName,
                                __autocomplete_queryID: e.queryID,
                                __autocomplete_algoliaCredentials: {
                                    appId: u,
                                    apiKey: a
                                }
                            })
                        }
                        ))
                    })
                }
                ))
            }
            ))
        }(n(n({}, e), {}, {
            userAgents: wr
        }))
    }
    ), "algolia");
    var Er = Ar({
        transformResponse: function(e) {
            return e.hits
        }
    });
    e.autocomplete = function(e) {
        var t, r = function() {
            var e = []
              , t = [];
            function n(n) {
                e.push(n);
                var r = n();
                t.push(r)
            }
            return {
                runEffect: n,
                cleanupEffects: function() {
                    var e = t;
                    t = [],
                    e.forEach((function(e) {
                        e()
                    }
                    ))
                },
                runEffects: function() {
                    var t = e;
                    e = [],
                    t.forEach((function(e) {
                        n(e)
                    }
                    ))
                }
            }
        }(), a = r.runEffect, l = r.cleanupEffects, c = r.runEffects, s = (t = [],
        {
            reactive: function(e) {
                var n = e()
                  , r = {
                    _fn: e,
                    _ref: {
                        current: n
                    },
                    get value() {
                        return this._ref.current
                    },
                    set value(e) {
                        this._ref.current = e
                    }
                };
                return t.push(r),
                r
            },
            runReactives: function() {
                t.forEach((function(e) {
                    e._ref.current = e._fn()
                }
                ))
            }
        }), m = s.reactive, v = s.runReactives, y = f(!1), g = f(e), h = f(void 0), _ = m((function() {
            return function(e) {
                var t, r = e.classNames, o = e.container, i = e.getEnvironmentProps, a = e.getFormProps, l = e.getInputProps, c = e.getItemProps, s = e.getLabelProps, f = e.getListProps, p = e.getPanelProps, m = e.getRootProps, v = e.panelContainer, y = e.panelPlacement, b = e.render, g = e.renderNoResults, h = e.renderer, _ = e.detachedMediaQuery, O = e.components, S = e.translations, j = u(e, _r), P = "undefined" != typeof window ? window : {}, w = Ut(P, o);
                w.tagName;
                var I = n(n({}, jr), h)
                  , A = {
                    Highlight: yr(I),
                    ReverseHighlight: br(I),
                    ReverseSnippet: gr(I),
                    Snippet: hr(I)
                };
                return {
                    renderer: {
                        classNames: Mt(Or, null != r ? r : {}),
                        container: w,
                        getEnvironmentProps: null != i ? i : function(e) {
                            return e.props
                        }
                        ,
                        getFormProps: null != a ? a : function(e) {
                            return e.props
                        }
                        ,
                        getInputProps: null != l ? l : function(e) {
                            return e.props
                        }
                        ,
                        getItemProps: null != c ? c : function(e) {
                            return e.props
                        }
                        ,
                        getLabelProps: null != s ? s : function(e) {
                            return e.props
                        }
                        ,
                        getListProps: null != f ? f : function(e) {
                            return e.props
                        }
                        ,
                        getPanelProps: null != p ? p : function(e) {
                            return e.props
                        }
                        ,
                        getRootProps: null != m ? m : function(e) {
                            return e.props
                        }
                        ,
                        panelContainer: v ? Ut(P, v) : P.document.body,
                        panelPlacement: null != y ? y : "input-wrapper-width",
                        render: null != b ? b : Sr,
                        renderNoResults: g,
                        renderer: I,
                        detachedMediaQuery: null != _ ? _ : getComputedStyle(P.document.documentElement).getPropertyValue("--aa-detached-media-query"),
                        components: n(n({}, A), O),
                        translations: n(n({}, {
                            clearButtonTitle: "Clear",
                            detachedCancelButtonText: "Cancel",
                            detachedSearchButtonTitle: "Search",
                            submitButtonTitle: "Submit"
                        }), S)
                    },
                    core: n(n({}, j), {}, {
                        id: null !== (t = j.id) && void 0 !== t ? t : d(),
                        environment: P
                    })
                }
            }(g.current)
        }
        )), O = m((function() {
            return _.value.core.environment.matchMedia(_.value.renderer.detachedMediaQuery).matches
        }
        )), S = m((function() {
            return qt(n(n({}, _.value.core), {}, {
                onStateChange: function(e) {
                    var t, n, r;
                    y.current = e.state.collections.some((function(e) {
                        return e.source.templates.noResults
                    }
                    )),
                    null === (t = h.current) || void 0 === t || t.call(h, e),
                    null === (n = (r = _.value.core).onStateChange) || void 0 === n || n.call(r, e)
                },
                shouldPanelOpen: g.current.shouldPanelOpen || function(e) {
                    var t = e.state;
                    if (O.value)
                        return !0;
                    var n = b(t) > 0;
                    if (!_.value.core.openOnFocus && !t.query)
                        return n;
                    var r = Boolean(y.current || _.value.renderer.renderNoResults);
                    return !n && r || n
                }
                ,
                __autocomplete_metadata: {
                    userAgents: wr,
                    options: e
                }
            }))
        }
        )), j = f(n({
            collections: [],
            completion: null,
            context: {},
            isOpen: !1,
            query: "",
            activeItemId: null,
            status: "idle"
        }, _.value.core.initialState)), P = {
            getEnvironmentProps: _.value.renderer.getEnvironmentProps,
            getFormProps: _.value.renderer.getFormProps,
            getInputProps: _.value.renderer.getInputProps,
            getItemProps: _.value.renderer.getItemProps,
            getLabelProps: _.value.renderer.getLabelProps,
            getListProps: _.value.renderer.getListProps,
            getPanelProps: _.value.renderer.getPanelProps,
            getRootProps: _.value.renderer.getRootProps
        }, w = {
            setActiveItemId: S.value.setActiveItemId,
            setQuery: S.value.setQuery,
            setCollections: S.value.setCollections,
            setIsOpen: S.value.setIsOpen,
            setStatus: S.value.setStatus,
            setContext: S.value.setContext,
            refresh: S.value.refresh,
            navigator: S.value.navigator
        }, I = m((function() {
            return Lt.bind(_.value.renderer.renderer.createElement)
        }
        )), A = m((function() {
            return rn({
                autocomplete: S.value,
                autocompleteScopeApi: w,
                classNames: _.value.renderer.classNames,
                environment: _.value.core.environment,
                isDetached: O.value,
                placeholder: _.value.core.placeholder,
                propGetters: P,
                setIsModalOpen: k,
                state: j.current,
                translations: _.value.renderer.translations
            })
        }
        ));
        function E() {
            Jt(A.value.panel, {
                style: O.value ? {} : Pr({
                    panelPlacement: _.value.renderer.panelPlacement,
                    container: A.value.root,
                    form: A.value.form,
                    environment: _.value.core.environment
                })
            })
        }
        function D(e) {
            j.current = e;
            var t = {
                autocomplete: S.value,
                autocompleteScopeApi: w,
                classNames: _.value.renderer.classNames,
                components: _.value.renderer.components,
                container: _.value.renderer.container,
                html: I.value,
                dom: A.value,
                panelContainer: O.value ? A.value.detachedContainer : _.value.renderer.panelContainer,
                propGetters: P,
                state: j.current,
                renderer: _.value.renderer.renderer
            }
              , r = !b(e) && !y.current && _.value.renderer.renderNoResults || _.value.renderer.render;
            !function(e) {
                var t = e.autocomplete
                  , r = e.autocompleteScopeApi
                  , o = e.dom
                  , i = e.propGetters
                  , u = e.state;
                Xt(o.root, i.getRootProps(n({
                    state: u,
                    props: t.getRootProps({})
                }, r))),
                Xt(o.input, i.getInputProps(n({
                    state: u,
                    props: t.getInputProps({
                        inputElement: o.input
                    }),
                    inputElement: o.input
                }, r))),
                Jt(o.label, {
                    hidden: "stalled" === u.status
                }),
                Jt(o.loadingIndicator, {
                    hidden: "stalled" !== u.status
                }),
                Jt(o.clearButton, {
                    hidden: !u.query
                }),
                Jt(o.detachedSearchButtonQuery, {
                    textContent: u.query
                }),
                Jt(o.detachedSearchButtonPlaceholder, {
                    hidden: Boolean(u.query)
                })
            }(t),
            function(e, t) {
                var r = t.autocomplete
                  , o = t.autocompleteScopeApi
                  , u = t.classNames
                  , a = t.html
                  , l = t.dom
                  , c = t.panelContainer
                  , s = t.propGetters
                  , f = t.state
                  , p = t.components
                  , m = t.renderer;
                if (f.isOpen) {
                    c.contains(l.panel) || "loading" === f.status || c.appendChild(l.panel),
                    l.panel.classList.toggle("aa-Panel--stalled", "stalled" === f.status);
                    var v = f.collections.filter((function(e) {
                        var t = e.source
                          , n = e.items;
                        return t.templates.noResults || n.length > 0
                    }
                    )).map((function(e, t) {
                        var l = e.source
                          , c = e.items;
                        return m.createElement("section", {
                            key: t,
                            className: u.source,
                            "data-autocomplete-source-id": l.sourceId
                        }, l.templates.header && m.createElement("div", {
                            className: u.sourceHeader
                        }, l.templates.header({
                            components: p,
                            createElement: m.createElement,
                            Fragment: m.Fragment,
                            items: c,
                            source: l,
                            state: f,
                            html: a
                        })), l.templates.noResults && 0 === c.length ? m.createElement("div", {
                            className: u.sourceNoResults
                        }, l.templates.noResults({
                            components: p,
                            createElement: m.createElement,
                            Fragment: m.Fragment,
                            source: l,
                            state: f,
                            html: a
                        })) : m.createElement("ul", i({
                            className: u.list
                        }, s.getListProps(n({
                            state: f,
                            props: r.getListProps({
                                source: l
                            })
                        }, o))), c.map((function(e) {
                            var t = r.getItemProps({
                                item: e,
                                source: l
                            });
                            return m.createElement("li", i({
                                key: t.id,
                                className: u.item
                            }, s.getItemProps(n({
                                state: f,
                                props: t
                            }, o))), l.templates.item({
                                components: p,
                                createElement: m.createElement,
                                Fragment: m.Fragment,
                                item: e,
                                state: f,
                                html: a
                            }))
                        }
                        ))), l.templates.footer && m.createElement("div", {
                            className: u.sourceFooter
                        }, l.templates.footer({
                            components: p,
                            createElement: m.createElement,
                            Fragment: m.Fragment,
                            items: c,
                            source: l,
                            state: f,
                            html: a
                        })))
                    }
                    ))
                      , d = m.createElement(m.Fragment, null, m.createElement("div", {
                        className: u.panelLayout
                    }, v), m.createElement("div", {
                        className: "aa-GradientBottom"
                    }))
                      , y = v.reduce((function(e, t) {
                        return e[t.props["data-autocomplete-source-id"]] = t,
                        e
                    }
                    ), {});
                    e(n(n({
                        children: d,
                        state: f,
                        sections: v,
                        elements: y
                    }, m), {}, {
                        components: p,
                        html: a
                    }, o), l.panel)
                } else
                    c.contains(l.panel) && c.removeChild(l.panel)
            }(r, t)
        }
        function C() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            l();
            var t = _.value.renderer
              , n = t.components
              , r = u(t, Ir);
            g.current = Vt(r, _.value.core, {
                components: Wt(n, (function(e) {
                    return !e.value.hasOwnProperty("__autocomplete_componentName")
                }
                )),
                initialState: j.current
            }, e),
            v(),
            c(),
            S.value.refresh().then((function() {
                D(j.current)
            }
            ))
        }
        function k(e) {
            e !== _.value.core.environment.document.body.contains(A.value.detachedOverlay) && (e ? (_.value.core.environment.document.body.appendChild(A.value.detachedOverlay),
            _.value.core.environment.document.body.classList.add("aa-Detached"),
            A.value.input.focus()) : (_.value.core.environment.document.body.removeChild(A.value.detachedOverlay),
            _.value.core.environment.document.body.classList.remove("aa-Detached")))
        }
        return a((function() {
            var e = S.value.getEnvironmentProps({
                formElement: A.value.form,
                panelElement: A.value.panel,
                inputElement: A.value.input
            });
            return Jt(_.value.core.environment, e),
            function() {
                Jt(_.value.core.environment, Object.keys(e).reduce((function(e, t) {
                    return n(n({}, e), {}, o({}, t, void 0))
                }
                ), {}))
            }
        }
        )),
        a((function() {
            var e = O.value ? _.value.core.environment.document.body : _.value.renderer.panelContainer
              , t = O.value ? A.value.detachedOverlay : A.value.panel;
            return O.value && j.current.isOpen && k(!0),
            D(j.current),
            function() {
                e.contains(t) && (e.removeChild(t),
                e.classList.remove("aa-Detached"))
            }
        }
        )),
        a((function() {
            var e = _.value.renderer.container;
            return e.appendChild(A.value.root),
            function() {
                e.removeChild(A.value.root)
            }
        }
        )),
        a((function() {
            var e = p((function(e) {
                D(e.state)
            }
            ), 0);
            return h.current = function(t) {
                var n = t.state
                  , r = t.prevState;
                (O.value && r.isOpen !== n.isOpen && k(n.isOpen),
                O.value || !n.isOpen || r.isOpen || E(),
                n.query !== r.query) && _.value.core.environment.document.querySelectorAll(".aa-Panel--scrollable").forEach((function(e) {
                    0 !== e.scrollTop && (e.scrollTop = 0)
                }
                ));
                e({
                    state: n
                })
            }
            ,
            function() {
                h.current = void 0
            }
        }
        )),
        a((function() {
            var e = p((function() {
                var e = O.value;
                O.value = _.value.core.environment.matchMedia(_.value.renderer.detachedMediaQuery).matches,
                e !== O.value ? C({}) : requestAnimationFrame(E)
            }
            ), 20);
            return _.value.core.environment.addEventListener("resize", e),
            function() {
                _.value.core.environment.removeEventListener("resize", e)
            }
        }
        )),
        a((function() {
            if (!O.value)
                return function() {}
                ;
            function e(e) {
                A.value.detachedContainer.classList.toggle("aa-DetachedContainer--modal", e)
            }
            function t(t) {
                e(t.matches)
            }
            var n = _.value.core.environment.matchMedia(getComputedStyle(_.value.core.environment.document.documentElement).getPropertyValue("--aa-detached-modal-media-query"));
            e(n.matches);
            var r = Boolean(n.addEventListener);
            return r ? n.addEventListener("change", t) : n.addListener(t),
            function() {
                r ? n.removeEventListener("change", t) : n.removeListener(t)
            }
        }
        )),
        a((function() {
            return requestAnimationFrame(E),
            function() {}
        }
        )),
        n(n({}, w), {}, {
            update: C,
            destroy: function() {
                l()
            }
        })
    }
    ,
    e.getAlgoliaFacets = function(e) {
        var t = Ar({
            transformResponse: function(e) {
                return e.facetHits
            }
        })
          , r = e.queries.map((function(e) {
            return n(n({}, e), {}, {
                type: "facet"
            })
        }
        ));
        return t(n(n({}, e), {}, {
            queries: r
        }))
    }
    ,
    e.getAlgoliaResults = Er,
    Object.defineProperty(e, "__esModule", {
        value: !0
    })
}
));